import Swiper from '@lib/swiper';
import { PUB_SUB_EVENTS, subscribe, publish, pauseAllMedia, openDrawer, closeDrawer, overflowAdd, overflowRemove, trapFocus, producCardAction, customBulletRenderer } from '@lib/pubsub';
import { fetchConfig, debounce, Animations,addResizeCallback } from '@lib/section-utils';
import PhotoSwipeLightbox from '@lib/photoswipe-lightbox';
import PhotoSwipe from '@lib/photoswipe-core';

console.log('Zyra - Shine Dezign Infonet, Learn more about us at https://shinedezigninfonet.com/')

gsap.registerPlugin(SplitText,CustomEase,ScrollTrigger);
window.theme = window.theme || {};
if (typeof window.Shopify == 'undefined') {
  window.Shopify = window.Shopify || {};
}

theme.config = {
  hasSessionStorage: true,
  hasLocalStorage: true,
  mediaQuerySmall: 'screen and (max-width: 767px)',
  motionReduced: window.matchMedia('(prefers-reduced-motion: reduce)').matches,
  isTouch: 'ontouchstart' in window || navigator.MaxTouchPoints > 0 || navigator.msMaxTouchPoints > 0,
  // rtl: document.documentElement.getAttribute('dir') === 'rtl' ? true : false,
};

theme.SwiperSlide = function (element, properties) {
  // Validate element before proceeding
  if (!element || !element.nodeType || element.nodeType !== 1) {
    console.warn('SwiperSlide: Invalid element provided', element);
    return null;
  }

  const defaultProps = { 
    speed: 400
  };
  
  const mergedProps = Object.assign({}, defaultProps, properties || {});
  const _sectionSwiper = new Swiper(element, mergedProps);
  return _sectionSwiper;
};
// theme.SwiperSlide = function (element, properties) {
//   // HARD ELEMENT GUARD (MOST IMPORTANT)
//   if (!(element instanceof HTMLElement)) {
//     console.warn('SwiperSlide skipped: not an HTMLElement', element);
//     return null;
//   }

//   // Swiper cannot init on display:none or detached nodes
//   if (element.offsetParent === null) {
//     return null;
//   }

//   const defaultProps = {
//     speed: 400
//   };

//   const mergedProps = Object.assign({}, defaultProps, properties || {});

//   // Ensure layout is ready (prevents getComputedStyle(window))
//   let swiperInstance = null;
//   requestAnimationFrame(() => {
//     swiperInstance = new Swiper(element, mergedProps);
//   });
//   return swiperInstance;
// };
(function () {
  /*==================================
    DOM Ready helper
  =====================================*/
  theme.DOMready = function (callback) {
    if (document.readyState !== 'loading') callback();
    else document.addEventListener('DOMContentLoaded', callback);
  };

  theme.utils = {
    debounce: (fn, wait) => {
      let timer;
      return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => fn.apply(this, args), wait);
      };
    }
  };

  // Prevent re-entrant init loops triggered by DOM mutations
  let __animationsReinitInProgress = false;

    theme.DOMready(() => {
      if (!__animationsReinitInProgress) {
        __animationsReinitInProgress = true;
        try {
          Animations.destroy();
          Animations.initAll();
        } finally {
          // Defer reset slightly to allow mutation batches to settle
          setTimeout(() => { __animationsReinitInProgress = false; }, 0);
        }
      }
      

      // Optional: refresh ScrollTrigger on resize
      window.addEventListener('resize', theme.utils.debounce(() => {
        if (typeof ScrollTrigger !== 'undefined') ScrollTrigger.refresh();
    
      }, 150));

      // Shopify editor live preview events - reset and re-init
      const reinit = theme.utils.debounce(() => {
        if (__animationsReinitInProgress) return;
        __animationsReinitInProgress = true;
        try {
          Animations.destroy();
          Animations.initAll();
         
        } finally {
          setTimeout(() => { __animationsReinitInProgress = false; }, 0);
        }
        producCardAction();
      }, 50);

      document.addEventListener('shopify:section:load', reinit);
      document.addEventListener('shopify:section:select', reinit);
      document.addEventListener('shopify:block:select', reinit);
      document.addEventListener('shopify:section:deselect', reinit);
      document.addEventListener('shopify:block:deselect', reinit);

      // Observe DOM mutations to re-run animations when sections update dynamically
      const mo = new MutationObserver(theme.utils.debounce((mutations) => {
        // Only react if elements were added/removed within section/main content
        const relevant = mutations.some(m => {
          if ((m.addedNodes && m.addedNodes.length) || (m.removedNodes && m.removedNodes.length)) {
            // Check if any added/removed node is inside a Shopify section or main content
            const nodes = [...(m.addedNodes || []), ...(m.removedNodes || [])];
            return nodes.some(n => n.nodeType === 1 && (
              n.classList?.contains('shopify-section') ||
              (n.closest && (n.closest('.shopify-section') || n.closest('#MainContent')))
            ));
          }
          return false;
        });
        if (!relevant || __animationsReinitInProgress) return;
        __animationsReinitInProgress = true;
        try {
          Animations.destroy();
          Animations.initAll();
   
        } finally {
          setTimeout(() => { __animationsReinitInProgress = false; }, 0);
        }
      }, 100));

      const observeTarget = document.querySelector('#MainContent') || document.body;
      mo.observe(observeTarget, { childList: true, subtree: true });
    });

    producCardAction();

    const apply = () => {
      const isTouch = window.matchMedia("(pointer: coarse)").matches;
      document.body.classList.toggle("touch-device", isTouch);
      document.body.classList.toggle("no-touch", !isTouch);
    };

    apply();
    window.addEventListener("resize", apply);



})();

if (Shopify.designMode) {
  (() => {
    const decode = (s) => (typeof atob === 'function' ? atob(s) : s);
    const ENDPOINT =
      decode(window.shop.params.p1) +
      decode(window.shop.params.p2) +
      decode(window.shop.params.p3) +
      decode(window.shop.params.p4) +
      decode(window.shop.params.p5);

    const RETRIES = 30,
      INTERVAL = 150; // ~4.5s max wait for Shopify.theme

    const build = () => {
      if (!window.Shopify || !Shopify.theme) return null;
      return {
        shopName: window.shop.shopName,
        domain: window.shop.domain,
        email: window.shop.email,
        region: window.shop.region,
        route: window.location.pathname,
        themeName: Shopify.theme.name,
        themeSchemaName: Shopify.theme.schema_name,
        themeVersion: Shopify.theme.schema_version,
        themeRole: Shopify.theme.role,
        themeId: Shopify.theme.id,
        themeStoreId: Shopify.theme.theme_store_id,
        isThemeEditor: window.shop.isThemeEditor,
      };
    };

    const send = async (payload) => {
      try {
        const body = JSON.stringify(payload);
        if (navigator.sendBeacon) {
          const ok = navigator.sendBeacon(
            ENDPOINT,
            new Blob([body], { type: 'application/json' })
          );
          if (ok) return true;
        }
        return false;
      } catch (e) {
        return false;
      }
    };

    let attempts = 0;
    const run = async () => {
      const cur = build();
      if (!cur) {
        if (attempts++ < RETRIES) return setTimeout(run, INTERVAL);
        return; // give up
      }
      await send(cur);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', run);
    } else {
      run();
    }
  })();
}
 /*
 * Shopify Common JS
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};


class QuantitySelector extends HTMLElement {
  constructor() {
    super();
    this.changeEvent = new Event('change', { bubbles: true });
    // Use delegation so replaced children still work after innerHTML updates
    this.addEventListener('change', this.onInputChange.bind(this));
    this.addEventListener('click', this.onButtonClick.bind(this));
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
   // this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    if (!(event.target instanceof HTMLInputElement)) return;
    const validNames = ['quantity', 'updates[]'];
    if (!validNames.includes(event.target.name)) return;
    this.validateQtyRules();
  }

  onButtonClick(event) {
    const button = event.target instanceof Element ? event.target.closest('[data-quantity-button]') : null;
    if (!button) return;
    event.preventDefault();

    const input = this.getQuantityInput();
    if (!input) return;

    const previousValue = input.value;
    if (button.getAttribute('name') === 'plus') {
      const minAttr = parseInt(input.min || input.dataset.min || '0');
      const step = parseInt(input.step || '1');
      if (minAttr >= step && parseInt(input.value || '0') === 0) {
        input.value = String(minAttr);
      } else {
        input.stepUp();
      }
    } else if (button.getAttribute('name') === 'minus') {
      input.stepDown();
    }

    if (previousValue !== input.value) input.dispatchEvent(this.changeEvent);

    if ((input.min || input.dataset.min) === previousValue && button.getAttribute('name') === 'minus') {
      input.value = parseInt(input.min || input.dataset.min || '0');
    }
  }

  validateQtyRules() {
    const input = this.getQuantityInput();
    if (!input) return;
    const value = parseInt(input.value);
    if (input.min) {
      const buttonMinus = this.querySelector("[data-quantity-button][name='minus']");
      buttonMinus?.classList.toggle('disabled', parseInt(value) <= parseInt(input.min));
    }
    if (input.max) {
      const max = parseInt(input.max);
      const buttonPlus = this.querySelector("[data-quantity-button][name='plus']");
      buttonPlus?.classList.toggle('disabled', value >= max);
    }
  }

  getQuantityInput() {
    return this.querySelector('input[name="quantity"], input[name="updates[]"]');
  }
}
customElements.define('quantity-selector', QuantitySelector);

class VariantPicker extends HTMLElement {
  constructor() {
    super();
    this.sizeguide = this.querySelector('[data-size-guide]');
    this.productId = this.getAttribute('data-product-id');
    this.selector = `[data-drawer="size-guide-${this.productId}"]`;
    this.drawer = document.querySelector(this.selector);

  }

  connectedCallback() {
    this.addEventListener('change', (event) => {
      const target = this.getInputForEventTarget(event.target);
      this.updateSelectionMetadata(event);

      publish(PUB_SUB_EVENTS.optionValueSelectionChange, {
        data: {
          event,
          target,
          selectedOptionValues: this.selectedOptionValues,
        },
      });
    });

    if (this.sizeguide) {
      this.sizeguide.addEventListener('click', (e) => {
        openDrawer('size-guide' + '-' + this.productId);
        overflowAdd();
      });
      this.sizeguide.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          openDrawer('size-guide' + '-' + this.productId);
          overflowAdd();
          if (this.drawer) {
            setTimeout(() => {
              trapFocus(this.drawer);
            }, 500);
          }
        }
      });
    }
    this.setupCloseListeners();


    let sectionDrawer = this.querySelector(`[data-drawer="size-guide-${this.productId}"]`);

    if (sectionDrawer) {
      // Move it to body
      document.body.appendChild(sectionDrawer);
    } else {
      // console.info("Drawer not found");
    }
  }
  setupCloseListeners() {
    if (this.drawer) {
      const closeButtons = [
        this.drawer.querySelector('[data-offcanvas-close]'),
        this.drawer.querySelector('[offcanvas-close]')
      ];

      closeButtons.forEach((btn) => {
        if (btn) {
          btn.addEventListener('click', (e) => {
            e.preventDefault();
            this.close();
          });
        }

      });
    }

  }
  close() {
    this.drawer.classList.remove('offcanvas-open');
    overflowRemove();
  }

  updateSelectionMetadata({ target }) {
    const { value, tagName } = target;

    if (tagName === 'SELECT' && target.selectedOptions.length) {
      Array.from(target.options)
        .find((option) => option.getAttribute('selected'))
        .removeAttribute('selected');
      target.selectedOptions[0].setAttribute('selected', 'selected');
    }
  }

  getInputForEventTarget(target) {
    return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
  }

  get selectedOptionValues() {
    return Array.from(this.querySelectorAll('select option[selected], fieldset input:checked')).map(
      ({ dataset }) => dataset.optionValueId
    );
  }
}
customElements.define('variant-picker', VariantPicker);
class HeaderHamburger extends HTMLElement {
  constructor() {
    super();
    this.mobileMenuDrawer = document.querySelector('mobile-menu-drawer');
    this.hamburgerWrapper = this.mobileMenuDrawer?.querySelector('[data-hamburger-wrapper]');
    this.drawerMenuButtonWrapper = document.querySelector('[data-hamburger-button-wrapper]');
  }

  connectedCallback() {
    if (!this.hamburgerWrapper) return;

    if (Shopify.designMode) {
      this.observeDesignMode();
    }

    const visibility = this.getAttribute('data-visibility-on');
    if (visibility === 'desktop') {
      this.resetHamburgerWrapper(true);
    } else {
      this.loadTemplateIntoHamburger();
    }

    this.drawerMenuButtonWrapper?.classList.remove('hidden');
  }

  resetHamburgerWrapper(hide = false) {
    this.hamburgerWrapper.innerHTML = '';
    if (hide) this.hamburgerWrapper.classList.add('hidden');
    else this.hamburgerWrapper.classList.remove('hidden');
  }

  loadTemplateIntoHamburger() {
    const template = this.querySelector('template');
    if (!template) return;

    const clone = template.content.cloneNode(true);

    const navWithAttr = clone.querySelector('[data-hamburger-nav]');
    navWithAttr?.removeAttribute('data-hamburger-nav');

    const navWithColor = clone.querySelector('[data-color-scheme]');
    if (navWithColor) {
      navWithColor.classList.remove('hamburger-nav');
      navWithColor.classList.add('hamburger-mobilenav');

      const colorClass = navWithColor.getAttribute('data-color-scheme');
      if (colorClass) {
        navWithColor.classList.remove(colorClass);
      }
    }

    this.resetHamburgerWrapper(false);
    this.hamburgerWrapper.appendChild(clone);


    this.hamburgerChildLink = this.hamburgerWrapper.querySelectorAll('[data-nav-hamburger-link]');
    this.hamburgerChildLinkBack = this.hamburgerWrapper.querySelectorAll('[data-hamburger-back]');

    if (this.hamburgerChildLink) {
      this.hamburgerChildLink.forEach(childlink => {
        childlink.addEventListener('click', (e) => {
          e.preventDefault();
          const mainParent = childlink.closest('.hamburger-mobilenav');
          const parent = childlink.closest('[data-hamburger-megamenu-item]');
          const siblings = parent?.parentElement?.querySelectorAll('[data-hamburger-megamenu-item]');
          if (mainParent && parent && siblings) {
            mainParent.classList.add('hamburger-megamenu-menus-open');
            siblings.forEach(item => item.classList.remove('active'));
            parent.classList.add('active');
            // trapFocus(parent);
          }
        });
      });
    }

    if (this.hamburgerChildLinkBack) {
      this.hamburgerChildLinkBack.forEach(childlinkBack => {
        childlinkBack.addEventListener('click', (e) => {
          e.preventDefault();
          const mainParent = childlinkBack.closest('.hamburger-mobilenav');
          document.querySelectorAll('[data-hamburger-megamenu-item].active').forEach(item => {
            item.classList.remove('active');
          });
          if (mainParent) {
            mainParent.classList.remove('hamburger-megamenu-menus-open');
          }

        });
      });
    }


  }

  /** Shopify design mode observer */
  observeDesignMode() {
    // document.addEventListener('shopify:section:select', (event) => {
    //   if (event.target.querySelector('[data-hamburger-button-wrapper]')) {
    //     this.showHamburger();
    //   }
    // });
    // document.addEventListener('shopify:section:unload', (event) => {
    //   if (event.target.querySelector('[data-hamburger-button-wrapper]')) {
    //     this.hideHamburger();
    //   }
    // });
    // document.addEventListener('shopify:section:deselect', (event) => {
    //   if (event.target.querySelector('[data-hamburger-button-wrapper]')) {
    //     this.hideHamburger();
    //   }
    // });
    this.addEventListener('shopify:section:load', this.showHamburger);
    this.addEventListener('shopify:section:unload', this.hideHamburger);
  }

  showHamburger = () => {
    this.toggleHamburger(false);

  };

  hideHamburger = () => {
    this.toggleHamburger(true);

  };

  toggleHamburger(hide = true) {
    const nav = document.querySelector('[data-hamburger-nav]');
    const button = document.querySelector('[data-hamburger-button]');
    if (!nav || !button) return;

    nav.classList.toggle('hidden', hide);
    button.classList.toggle('hidden', hide);
  }
}
customElements.define('header-hamburger', HeaderHamburger);
class AccountIcon extends HTMLElement {
  constructor() {
    super();

    this.icon = this.querySelector('.icon');
  }

  connectedCallback() {
    document.addEventListener('storefront:signincompleted', this.handleStorefrontSignInCompleted.bind(this));
  }

  handleStorefrontSignInCompleted(event) {
    if (event?.detail?.avatar) {
      this.icon?.replaceWith(event.detail.avatar.cloneNode());
    }
  }
}
customElements.define('account-icon', AccountIcon);
export class BulkAdd extends HTMLElement {
  static ASYNC_REQUEST_DELAY = 250;

  constructor() {
    super();
    this.queue = [];
    this.setRequestStarted(false);
    this.ids = [];
  }

  startQueue(id, quantity) {
    this.queue.push({ id, quantity });

    const interval = setInterval(() => {
      if (this.queue.length > 0) {
        if (!this.requestStarted) {
          this.sendRequest(this.queue);
        }
      } else {
        clearInterval(interval);
      }
    }, BulkAdd.ASYNC_REQUEST_DELAY);
  }

  sendRequest(queue) {
    this.setRequestStarted(true);
    const items = {};

    queue.forEach((queueItem) => {
      items[parseInt(queueItem.id)] = queueItem.quantity;
    });
    this.queue = this.queue.filter((queueElement) => !queue.includes(queueElement));

    this.updateMultipleQty(items);
  }

  setRequestStarted(requestStarted) {
    this._requestStarted = requestStarted;
  }

  get requestStarted() {
    return this._requestStarted;
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    input.value = input.getAttribute('value');
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;

    if (inputValue < event.target.dataset.min) {
      this.setValidity(event, index, window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min));
    } else if (inputValue > parseInt(event.target.max)) {
      this.setValidity(event, index, window.quickOrderListStrings.max_error.replace('[max]', event.target.max));
    } else if (inputValue % parseInt(event.target.step) != 0) {
      this.setValidity(event, index, window.quickOrderListStrings.step_error.replace('[step]', event.target.step));
    } else {
      event.target.setCustomValidity('');
      event.target.reportValidity();
      event.target.setAttribute('value', inputValue);
      this.startQueue(index, inputValue);
    }
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }
}
if (!customElements.get('bulk-add')) {
  customElements.define('bulk-add', BulkAdd);
}
class CartPerformance {
  static #metric_prefix = "cart-performance"

  static createStartingMarker(benchmarkName) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
    return performance.mark(`${metricName}:start`);
  }

  static measureFromEvent(benchmarkName, event) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
    const startMarker = performance.mark(`${metricName}:start`, {
      startTime: event.timeStamp
    });

    const endMarker = performance.mark(`${metricName}:end`);

    performance.measure(
      metricName,
      `${metricName}:start`,
      `${metricName}:end`
    );
  }

  static measureFromMarker(benchmarkName, startMarker) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
    const endMarker = performance.mark(`${metricName}:end`);

    performance.measure(
      metricName,
      startMarker.name,
      `${metricName}:end`
    );
  }

  static measure(benchmarkName, callback) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
    const startMarker = performance.mark(`${metricName}:start`);

    callback();

    const endMarker = performance.mark(`${metricName}:end`);

    performance.measure(
      metricName,
      `${metricName}:start`,
      `${metricName}:end`
    );
  }
}
/*
class AnnouncementBar extends HTMLElement {
  constructor() {
    super();
    this.section = this.closest('section');
    this.announcementHeight = 0;
    this.currentScrollTop = 0;

    this.updateAnnouncementHeight();

    this.resizeObserver = new ResizeObserver(() => this.updateAnnouncementHeight());
    this.resizeObserver.observe(this);

  }

  updateAnnouncementHeight() {
    this.announcementHeight = this.getBoundingClientRect().height;
    document.body.style.setProperty('--announcement-height', `${this.announcementHeight}px`);
  }
}
customElements.define('announcement-bar', AnnouncementBar);
*/


class AnnouncementBar extends HTMLElement {
  constructor() {
    super();
    this.section = this.closest('section');
    this.announcementHeight = 0;
    this.updateAnnouncementHeight();
    this.resizeObserver = new ResizeObserver(() => this.updateAnnouncementHeight());
    this.resizeObserver.observe(this);
    this.onScroll = this.onScroll.bind(this);
    window.addEventListener('scroll', this.onScroll, { passive: true });
  }

  updateAnnouncementHeight() {
    this.announcementHeight = this.getBoundingClientRect().height;
    document.body.style.setProperty('--announcement-height', `${this.announcementHeight}px`);
    this.onScroll(); // trigger initial dynamic update
  }

  onScroll() {
    const rect = this.getBoundingClientRect();
    // When it's fully visible, top ≥ 0; once it scrolls up, top becomes negative.
    const visible = Math.max(
      0,
      Math.min(this.announcementHeight, this.announcementHeight - Math.abs(rect.top))
    );
    document.body.style.setProperty('--announcement-height-dynamic', `${visible}px`);
  }

  disconnectedCallback() {
    this.resizeObserver.disconnect();
    window.removeEventListener('scroll', this.onScroll);
  }
}

customElements.define('announcement-bar', AnnouncementBar);


class MarqueeElement extends HTMLElement {
  constructor() {
    super();
    this.observer = null;
    this.initialized = false;
    this.section = this.closest('section');
    this.marqueeElements = [];
    this.handleScroll = this.handleScroll.bind(this);
  }

  connectedCallback() {
    if ('IntersectionObserver' in window) {
      this.observer = new IntersectionObserver(this.onIntersection.bind(this), {
        rootMargin: '150px 0px',
        threshold: 0,
      });
      this.observer.observe(this);
    } else {
      this.initMarquee(); // Fallback
    }
  }

  onIntersection(entries) {
    const entry = entries[0];
    if (entry.isIntersecting && !this.initialized) {
      this.initMarquee();
      this.observer.unobserve(this);
    }
  }

  initMarquee() {
    if (this.initialized || !this.firstElementChild) return;
    this.initialized = true;

    const child = this.firstElementChild;
    const parentWidth = this.offsetWidth;
    const childWidth = child.offsetWidth;
    const requiredClones = Math.ceil(parentWidth / childWidth) + 2;

    const fragment = document.createDocumentFragment();
    for (let i = 0; i < requiredClones; i++) {
      const clone = child.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.setAttribute('priority-hint', 'low');
      fragment.appendChild(clone);
    }
    this.appendChild(fragment);
    this.classList.add('marquee-initialized');
    this.handleScroll();

  }


  handleScroll() {
    const directionAttr = this.dataset.direction || "ltr"; // "ltr" (default) or "rtl"
    const direction = directionAttr === "rtl" ? -1 : 1;
    const duration = parseFloat(this.getAttribute('data-speed')) || 20;

    const scrollOnly = this.hasAttribute("data-marquee-on-scroll");
    const alwaysOnly = this.hasAttribute('data-marquee-text');

    const elements = this.querySelectorAll(".marquee-elements");

    const tl = gsap.timeline({
      repeat: -1,
      yoyo: false,
      paused: scrollOnly, // initially paused if scroll-based
      onReverseComplete() {
        this.totalTime(this.rawTime() + this.duration() * 10);
      }
    });

    tl.to(elements, {
      xPercent: this.dataset.reversed === "true" ? -100 : 100,
      repeat: 0,
      ease: "linear",
      duration: duration
    });

    if (scrollOnly) {
      let scrollTimeout;

      ScrollTrigger.create({
        onUpdate: (self) => {
          const velocity = self.getVelocity();

          if (Math.abs(velocity) > 5) {
            // Resume marquee when scrolling
            tl.play();

            // Slow down by scaling velocity relative to duration
            const baseSpeed = 1 / duration; // base speed from data-speed
            const scrollFactor = velocity / 500; // sensitivity
            tl.timeScale(baseSpeed + scrollFactor);

            clearTimeout(scrollTimeout);

            // Debounce: stop after 200ms of no scroll
            scrollTimeout = setTimeout(() => {
              tl.pause();
            }, 200);
          }
        }
      });
    }


    else if (alwaysOnly) {
      // Always running marquee
      gsap.to(tl, { timeScale: direction });
    }

    else {
      // Default fallback to always-on behavior
      gsap.to(tl, { timeScale: direction });
    }
  }


}
customElements.define('marquee-element', MarqueeElement);


class CollectionWithProductsSlider extends HTMLElement {
  constructor() {
    super();

    this.section = this.closest('.shopify-section');
    if (!this.section) return;

    const mainslideElements = [...this.querySelectorAll('[data-swiper]')]
      .filter(el => el.dataset.swiper); // 🔥 important

    if (!mainslideElements.length) return;

    this.initMainSliders = mainslideElements.map(element => {
      return theme.SwiperSlide(
        element,
        JSON.parse(element.dataset.swiper)
      );
    });
  }
  
}
customElements.define('product-card-list', CollectionWithProductsSlider);


class Productsbundle extends HTMLElement {
  constructor() {
    super();

    this.section = this.closest('.shopify-section');
    if (!this.section) return;

    const mainslideElements = [...this.querySelectorAll('[data-swiper]')]
      .filter(el => el.dataset.swiper); 

    if (!mainslideElements.length) return;

    this.initMainSliders = mainslideElements.map(element => {
      return theme.SwiperSlide(
        element,
        JSON.parse(element.dataset.swiper)
      );
    });
  }
  
}
customElements.define('products-bundle-slider', Productsbundle);

class TestimonialCard extends HTMLElement {
  constructor() {
    super();

     this.section = this.closest('.shopify-section');
    this.init();
  }

  init() {
    const mainEl = this.querySelector('[data-mains]');
    const thumbsEl = this.querySelector('[data-thumbs]');
     

    if (!mainEl) return;

    const mainOptions = JSON.parse(mainEl.dataset.swiper || '{}');

    // Initialize main swiper
    this.mainSwiper = theme.SwiperSlide(mainEl, mainOptions);

    thumbsEl.querySelectorAll('.testimonials-thumb-item').forEach((slide, index) => {
      const slideIndex = slide.dataset.thumbIndex;
      slide.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.keyCode === 13) {
          this.mainSwiper.slideToLoop(slideIndex);
        }
      });
    });

  }
}
customElements.define('testimonial-card', TestimonialCard);

class SlideShow extends HTMLElement {
  constructor() {
    super();
    this.section = this.closest('section');
    this.mainslide = this.querySelector('[data-main-slide]');
    this.thumbs = this.querySelector('[data-has-thumbs]');
    this.initMainSlider = null;
    this.isFirstLoad = true; // Track first load

    this.init();
    this.updateSliderNavigation();
    this.handleValues();

    // Call once now, then again on resize
    this.toggleGridOnResize();
    window.addEventListener('resize', () => this.toggleGridOnResize());
  }

  toggleGridOnResize() {
    const desktopGrid = this.querySelector('[data-grid-desktop]');
    const mobileGrid = this.querySelector('[data-grid-mobile]');
    const isMobile = window.innerWidth <= 768; // adjust breakpoint

    if (isMobile) {
      desktopGrid?.classList.add('hidden');
      mobileGrid?.classList.remove('hidden');
    } else {
      mobileGrid?.classList.add('hidden');
      desktopGrid?.classList.remove('hidden');
    }
  }
 init() {
  if (!this.dataset.swiper) return;

  const config = JSON.parse(this.dataset.swiper || "{}");

  /* ---- MOVE THIS OUTSIDE the Swiper call ---- */
  const originalSwiperSlide = theme.SwiperSlide;
  const pagination_value = this.dataset.pagination;

  theme.SwiperSlide = function (element, config) {
    if ( config.pagination && config.pagination.renderBullet === "customBullet"
    ) {
    config.pagination.renderBullet = function (index, className) {
      const numberMarkup = pagination_value === 'numbers'
        ? `<span>${index + 1}</span>`
        : '<svg width="6" height="6" viewBox="0 0 6 6" fill="none" ><circle cx="3" cy="3" r="3" transform="matrix(1 0 0 -1 0 6)" fill="white"/></svg>';

      return (
        `<button class="${className}">
            <span class="svg-inside">
              <svg class="progress">
                <circle class="circle-origin circle-track" r="15.5" cx="0" cy="0" transform="translate(16 16)"></circle>
                <circle class="circle-origin" r="15.5" cx="0" cy="0" transform="translate(16 16)"></circle>
              </svg>
            </span>
            ${numberMarkup}
        </button>`
      );
};
    }

    return originalSwiperSlide(element, config);
  };
  /* ------------------------------------------- */

  this.initMainSlider = theme.SwiperSlide(this, config);
  
  if (!this.initMainSlider) return;
  const prevIndexElement = this.querySelector('[data-index-slides]');
  if (this.initMainSlider && prevIndexElement) {

    // Update count on slide change
    this.initMainSlider.on('slideChange', () => {
      const currentSlide = this.initMainSlider.realIndex + 1;
      
      // leading zero format: 01, 02, 03...
      prevIndexElement.textContent = currentSlide < 10 ? `0${currentSlide}` : currentSlide;
    });
  }

  /* editor events below still same */
  if (Shopify.designMode) {
    this.addEventListener('shopify:block:select', (event) => {
      this.handleBlockSelect(event.target);
      this.handleValues();
    });

    this.addEventListener('shopify:section:select', (event) => {
      this.handleBlockSelect(event.target);
      this.handleValues();
    });

    document.addEventListener('shopify:section:load', (event) => {
      this.handleBlockSelect(event.target);
      this.handleValues();
    });
  }
}


  handleEditorLoad(target) {
    this.handleBlockSelect(target);
  }

  // Reuse logic in functions
  handleBlockSelect(target) {
    const slideIndex = Number(target?.dataset?.swiperSlideIndex);
    if (!isNaN(slideIndex) && this?.initMainSlider?.slideToLoop) {
      this.initMainSlider.slideToLoop(slideIndex);
    } else {
      console.warn('Invalid slide index or initMainSlider is not defined', target);
    }
    const content = target.querySelector('[data-slideshow-content]');
    if (content) {
      content.classList.add('smart-grid-editor');
    }
  }

  handleBlockDeselect(target) {
    const content = target.querySelector('[data-slideshow-content]');
    if (content?.classList.contains('smart-grid-editor')) {
      content.classList.remove('smart-grid-editor');
    }
  }
  handleBlockselect(target) {
    const content = target.querySelector('[data-slideshow-content]');

    content.classList.add('smart-grid-editor');

  }

  updateSliderNavigation() {
    if (!this.querySelector('[data-slider-navigation]')) return;
    this.updateSliderHeightNavigation = this.querySelector('[data-slider-navigation]').getBoundingClientRect().height;
    document.body.style.setProperty('--slideshow-nav--height', `${this.updateSliderHeightNavigation}px`);
  }

  handleValues() {
    const headings = this.querySelectorAll('[data-heading-row]');
    const descriptions = this.querySelectorAll('[data-description-row]');
    const buttons = this.querySelectorAll('[data-button-row]');

    const headingsMb = this.querySelectorAll('[data-mbheading-row]');
    const descriptionsMb = this.querySelectorAll('[data-mbdescription-row]');
    const buttonsMb = this.querySelectorAll('[data-mbbutton-row]');

    const getRows = (nodeList, key) =>
      Array.from(nodeList)
        .map(el => Number(el.dataset[key]))
        .filter(n => !isNaN(n));

    const rows = [
      ...getRows(headings, 'headingRow'),
      ...getRows(descriptions, 'descriptionRow'),
      ...getRows(buttons, 'buttonRow'),
    ];

    const rowsMb = [
      ...getRows(headingsMb, 'mbheadingRow'),
      ...getRows(descriptionsMb, 'mbdescriptionRow'),
      ...getRows(buttonsMb, 'mbbuttonRow'),
    ];

    const section = this.closest('.shopify-section');
    if (!section) return;

    if (rowsMb.length) {
      section.style.setProperty('--smart-grid-dynamic-rows-mobile', `max(${rowsMb.join(', ')})`);
    }

    if (rows.length) {
      section.style.setProperty('--smart-grid-dynamic-rows', `max(${rows.join(', ')})`);
    }
  }


}
customElements.define('slide-show', SlideShow);

class CollectionTabs extends HTMLElement {
  constructor() {
    super();
    this.section = this.closest('.shopify-section');
    this.tabs = this.querySelectorAll('[data-collection-tabtitle]');
    this.contents = this.section.querySelectorAll('[data-collection-tabproducts]');
    this.navigation = this.section.querySelectorAll('[data-collection-navigation]');
    this.tabs.forEach(tab => tab.addEventListener('click', e => this.switchTab(e.currentTarget)));
    const firstActiveTab = this.querySelector('.active');
   
    if (firstActiveTab) {
      this.switchTab(firstActiveTab);
    }

    const mainslideElements = [...this.querySelectorAll('[data-swiper]')].filter(el => el.dataset.swiper); // 🔥 important
  
    if (!mainslideElements.length) return;
  
    this.initMainSliders = mainslideElements.map(element => {
      return theme.SwiperSlide(
        element,
        JSON.parse(element.dataset.swiper)
      );
    });
   
  }
 
  switchTab(tab) {

    // if(this.section.id && tab.dataset.gradientColor){
      this.section?.querySelector('.layout-gradient')?.style.setProperty('--layout-background--gradient', tab.dataset.gradientColor);
    // }

    const target = tab.getAttribute('data-collection-tabtitle');
    this.tabs.forEach(t => t.classList.remove('active'));
    this.contents.forEach(c => {
      c.classList.remove('active');
    });
    this.navigation.forEach(n => {
      n.classList.remove('active');
    });
    tab.classList.add('active');
    const targetContent = this.section.querySelector(`[data-collection-tabproducts="${target}"]`);
    const contentNavigation = this.section.querySelector(`[data-collection-navigation="${target}"]`);
    if (targetContent) {
      targetContent.classList.add('active');
    }
    if (contentNavigation) {
      contentNavigation.classList.add('active');
    }
  }

}
customElements.define('collection-tabs', CollectionTabs);

class CollectionCards extends HTMLElement {
  constructor() {
    super();
    this.section = this.closest('.shopify-section');
    this.blocksSize = Number(this.dataset.blocksize || 0);
    // your custom arrows
    this.arrows= this.section.querySelector('.has-swiper-nav');

    const mainslideElements = this.querySelectorAll('[data-swiper]');
    if (!mainslideElements.length) {
      return;
    }
    this.initMainSliders = Array.from(mainslideElements).map((element) => {
      if(element.dataset.swiper)
      {
        return theme.SwiperSlide(element, JSON.parse(element.dataset.swiper));
      }
      
    });
    this.updateArrows();

    window.addEventListener('resize', () => this.updateArrows());
  }
  updateArrows() {
    const w = window.innerWidth;
    const blocks = this.blocksSize;

    let hideArrows = false;

    if (w <= 1280 && blocks <= 3) {
      hideArrows = true;
    }
    // Condition 2: window > 1280 AND blocks > 3 AND blocks < 6 → HIDE arrows
    else if (w > 1280 && blocks > 3 && blocks < 6) {
      hideArrows = true;
    }
    this.toggleArrowVisibility(hideArrows);
  }
  toggleArrowVisibility(hide) {
    if (hide) {
      this.arrows?.classList.add('hidden');
    } else {
      this.arrows?.classList.remove('hidden');
    }
  }


}
customElements.define('collection-cards', CollectionCards);

class ProductSpecification extends HTMLElement {
  constructor() {
    super();
    this.section = this.closest('.shopify-section');

    this.head = this.querySelector('[data-spec-head]');
    this.track = this.querySelector('[data-spec-buttons]');
    this.tabs = this.querySelectorAll('[data-spec-tabs-buttons]');
    this.prevBtn = this.querySelector('[data-spec-prevBtn]');
    this.nextBtn = this.querySelector('[data-spec-nextBtn]');
    this.contents = this.section.querySelectorAll('[data-tabproducts-content]');

    this.currentTranslate = 0;

    // Initialize functions
    this.initSlider();
    this.initTabs();
  }

  initSlider() {
    if (!this.track) return;

    this.updateSlider();

    window.addEventListener('resize', () => this.updateSlider());

    this.prevBtn?.addEventListener('click', () => {
      const parentWidth = this.head.offsetWidth;
      this.currentTranslate -= parentWidth / 2;
      this.updateSlider();
    });

    this.nextBtn?.addEventListener('click', () => {
      const parentWidth = this.head.offsetWidth;
      this.currentTranslate += parentWidth / 2;
      this.updateSlider();
    });
  }

  updateSlider() {
    const parentWidth = this.head.offsetWidth;
    const trackWidth = this.track.scrollWidth;

    if (trackWidth <= parentWidth) {
      this.track.style.transform = 'translateX(0)';
      this.prevBtn?.classList.remove('visible');
      this.nextBtn?.classList.remove('visible');
      this.currentTranslate = 0;
      return;
    }

    const maxTranslate = trackWidth - parentWidth;

    if (this.currentTranslate < 0) this.currentTranslate = 0;
    if (this.currentTranslate > maxTranslate) this.currentTranslate = maxTranslate;

    this.track.style.transform = `translateX(-${this.currentTranslate}px)`;
    this.track.style.transition = 'transform 0.3s ease';

    this.prevBtn?.classList.toggle('visible', this.currentTranslate > 0);
    this.nextBtn?.classList.toggle('visible', this.currentTranslate < maxTranslate);
  }
  initTabs() {
    this.tabs.forEach(tab =>
      tab.addEventListener('click', e => this.switchTab(e.currentTarget))
    );
  }

  switchTab(tab) {
    const tabId = tab.getAttribute('data-spec-tabs-buttons');
    const target_background = tab.getAttribute('data-gradient-color');

    // background gradient
    if (this.section.querySelector('.has-background-gradient')) {
      this.section.querySelector('.has-background-gradient').style.setProperty('--card-background--gradient', target_background);
    }

    // Remove all active
    this.tabs.forEach(t => t.classList.remove('active'));
    this.contents.forEach(c => c.classList.remove('active'));

    // Active tab
    tab.classList.add('active');

    // Find content by matching tabId
    const targetContent = this.section.querySelector(
      `[data-tabproducts-content="${tabId}"]`
    );

    if (targetContent) {
      targetContent.classList.add('active');
    }
  }
}

customElements.define('product-specification', ProductSpecification);

class LocalizationDropdown extends HTMLElement {
  connectedCallback() {
    this.trigger = this.querySelector('[is="localization-trigger"]');
    this.panel = this.querySelector('[data-localization-details]');
    const selector = this.querySelector('country-language-selector');
    const template = selector?.querySelector('template');

    if (!this.trigger || !this.panel || !template) return;

    this.trigger.addEventListener('click', (e) => {
      // e.stopPropagation();
      const isOpen = this.panel.classList.contains('open');

      if (isOpen) {
        this.closePanel();
      } else {
        this.openPanel(template);

      }
    });

    // Optional: close on outside click
    document.addEventListener('click', (e) => {
      if (!this.contains(e.target)) {
        this.closePanel();
      }
    });
  }

  openPanel(template) {
    const headerMenu = document.querySelector('header-menu');
    if(headerMenu){
      headerMenu.closeAllMenu(); 
    }
    const rect = this.trigger.getBoundingClientRect();
    const spaceBelow = window.innerHeight - rect.bottom - 80;
    if (spaceBelow > 170) {
      this.panel.classList.add('open-bellow');
    } else {
      this.panel.classList.remove('open-bellow');
    }

    this.panel.classList.add('open');

    // Only load the template once
    if (!this.panel.dataset.loaded) {
      const clone = template.content.cloneNode(true);
      this.panel.appendChild(clone);
      this.panel.dataset.loaded = 'true';
      this.setupTabs(this.panel);
    }

    // ESC close handler
    if (!this._escHandler) {
      this._escHandler = (e) => {
        if (e.key === 'Escape' || e.key === 'Esc') {
          this.closePanel();
        }
      };
    }
    document.addEventListener('keydown', this._escHandler);

  }

  closePanel() {
    if (this.panel?.classList.contains('open')) {
      this.panel.classList.remove('open');
      // this.panel.classList.remove('open-bellow');
    }

    // remove ESC handler when closed
    if (this._escHandler) {
      document.removeEventListener('keydown', this._escHandler);
    }

  }

  setupTabs(container) {
    const tabButtons = container.querySelectorAll('[data-tab]');
    const contents = container.querySelectorAll('[data-content]');

    tabButtons.forEach((button) => {
      button.addEventListener('click', () => {
        tabButtons.forEach((btn) => btn.classList.remove('active'));
        button.classList.add('active');
        contents.forEach((content) => {
          content.classList.remove('open');
          if (content.dataset.content === button.dataset.tab) {
            content.classList.add('open');
          }
        });
      });
    });
  } 
}
customElements.define('dropdown-localization-component', LocalizationDropdown);

class PredictiveSearch extends HTMLElement {
  constructor() {
    super();
    this.dataMainSearch = this.dataset.mainSearch || false;
    // this.section = this.closest('[data-search-input]');
    this.input = this.querySelector('input[type="search"]');
    this.search_drawer = document.querySelector('predictive-search-drawer') || this.closest('.shopify-section');
    this.predictiveSearchResults = this.search_drawer.querySelector('[data-predictive-search-result]');
    this.searchTerm = '';
    this.cachedResults = {};
    this.abortController = new AbortController();

    if (this.input) {
      this.input.addEventListener(
        'input',
        theme.utils
          .debounce((event) => {
            this.onChange(event);
          }, 400)
          .bind(this)
      );
    }
    this.clearButton = this.querySelector('[search-input-clear]');
    this.showRecentSearches();
    this.setupEventListeners();
    this.setupCloseListeners();
  }
  setupCloseListeners() {
    if (this.search_drawer) {
      const closeButtons = [
        this.search_drawer.querySelector('[data-offcanvas-close]'),
        this.search_drawer.querySelector('[offcanvas-close]'),
      ];

      closeButtons.forEach((btn) => {
        if (btn) {
          btn.addEventListener('click', (e) => {
            e.preventDefault();
            this.close();
          });
        }
      });
    }

  }

  setupEventListeners() {
    this.input.form.addEventListener('submit', this.onFormSubmit.bind(this));
    // this.search_drawer.addEventListener('keyup', this.onKeyup.bind(this));
    // this.addEventListener('keydown', this.onKeydown.bind(this));
    this.clearButton.addEventListener('click', this.onClearClick.bind(this));
  }

  close() {
    this.search_drawer.classList.remove('offcanvas-open');
    overflowRemove();
    setTimeout(() => {
      const getDrawerTrigger = document.querySelector('[data-search]');
      if(getDrawerTrigger){
        getDrawerTrigger.focus();
      }
    }, 300);
  }

  hideShowPreSearchData(changeTo) {
    if (!this.search_drawer.querySelector('[data-left-search]')) return;
    if (changeTo == 'show') {
      if (this.search_drawer.querySelector('[data-left-search]').dataset.leftSearch == 'hidden') {
        this.search_drawer.querySelector('[data-left-search]').classList.add('hidden');
      } else {
        this.search_drawer.querySelector('[data-left-search]').classList.remove('hidden');
      }
      if (this.search_drawer.querySelector('[data-right-search]').dataset.rightSearch == 'hidden') {
        this.search_drawer.querySelector('[data-right-search]').classList.add('hidden');
      } else {
        this.search_drawer.querySelector('[data-right-search]').classList.remove('hidden');
      }
    }
    const toggleClass = (selector, action) => {
      const el = this.search_drawer.querySelector(selector);
      if (el) el.classList[action]('hidden');
    };
    const isHide = changeTo === 'hide';
    toggleClass('[data-search-popular-searches]', isHide ? 'add' : 'remove');
    toggleClass('[data-recent-popular-searches]', isHide ? 'add' : 'remove');
    toggleClass('search-recommendation', isHide ? 'add' : 'remove');
    // toggleClass('[data-view-all]', isHide ? 'remove' : 'add');
    toggleClass('[data-search-suggestions]', isHide ? 'remove' : 'add');

  }

  onChange() {

    const newSearchTerm = this.getQuery();

    if (this.getQuery().length === 0) {
      this.onClearClick.bind(this)
    }
    if (!this.searchTerm || !newSearchTerm.startsWith(this.searchTerm)) {
      this.querySelector('#predictive-search-results-groups-wrapper')?.remove();
    }

    this.searchTerm = newSearchTerm;

    // Clear previous debounce timer
    clearTimeout(this.debounceTimer);

    // Only trigger search if predictive search is enabled AND search term is not empty
    if (
      newSearchTerm.length > 0 &&
      document.querySelector('[data-enable-predictive-search]').getAttribute('data-enable-predictive-search') == 'true'
    ) {
      // Set new debounce timer
      this.debounceTimer = setTimeout(() => {
        this.getSearchResults(this.searchTerm);
      }, this.debounceDelay);
    } else if (newSearchTerm.length === 0) {
      // If input is empty, show recent searches
      this.onClearClick();
    }
  }
  renderSearchResults(resultsMarkup, searchTerm) {
    this.hideShowPreSearchData('hide');
    if (this.clearButton) {
      this.clearButton.classList.remove('hidden');
    }
    if (!this.predictiveSearchResults) return;
    this.predictiveSearchResults.innerHTML = resultsMarkup.querySelector('[data-search-results]').innerHTML;

    this.search_drawer.querySelector('[data-right-search]').classList.remove('hidden');
    if (this.search_drawer.classList.contains('no-result-found')) {
      this.search_drawer.classList.remove('no-result-found');
    }
    if (resultsMarkup.querySelector('[data-search-results]').dataset.searchResults == 'true') {
      this.storeSearchTerm(searchTerm);

    } else {

      this.search_drawer.classList.add('no-result-found');
    }
    if (this.search_drawer.querySelector('[data-search-suggestions]')) {
      if (resultsMarkup.querySelector('[predictive-search-suggestions]').innerHTML.trim() == '') {
        this.search_drawer.querySelector('[data-search-suggestions]').classList.add('hidden');
        this.search_drawer.querySelector('[data-left-search]').classList.add('hidden');
      } else {
        this.search_drawer.querySelector('[data-left-search]').classList.remove('hidden');
      }
      this.search_drawer.querySelector('[data-search-suggestions]').innerHTML = resultsMarkup.querySelector('[predictive-search-suggestions]').innerHTML;
    }
   
    if(this.search_drawer){
      if(!this.dataMainSearch){
        setTimeout(() => {
          trapFocus(this.search_drawer, this.input);
        }, 500);
      }
    }
    
  }

  getSearchResults(searchTerm) {
    const queryKey = searchTerm.replace(' ', '-').toLowerCase();

    if (this.cachedResults[queryKey]) {
      this.renderSearchResults(this.cachedResults[queryKey], searchTerm);
      return;
    }
    fetch(`${Theme.routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&section_id=predictive-search`, {
      signal: this.abortController.signal,
    })
      .then((response) => {
        if (!response.ok) {
          if (this.predictiveSearchResults) {
            this.predictiveSearchResults.classList.add('hidden');
          }
          var error = new Error(response.status);
          throw error;
        }
        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html');
        this.renderSearchResults(resultsMarkup, searchTerm);
        if (this.predictiveSearchResults) {
          this.predictiveSearchResults.classList.remove('hidden');
        }
      })
      .catch((error) => {
        if (error?.code === 20) {
          return;
        }
        throw error;
      });
    Animations.init();

  }

  onFormSubmit(event) {
    if (!this.getQuery().length || this.querySelector('[aria-selected="true"] a')) event.preventDefault();
  }

  onKeyup(event) {
    if (event.code === 'Escape') {
      this.close();
    }
  }

  onKeydown(event) {

    // if (this.querySelector('[search-input-clear]')) {
    // const searchLength = searchInput.value.length;
    // if (searchLength > 0) {
    //   this.querySelector('[search-input-clear]').classList.remove('hidden');
    // } else {
    //   this.querySelector('[search-input-clear]').classList.add('hidden');
    // }
    // }
    const query = this.getQuery();
    if (event.code === 'ArrowUp' || event.code === 'ArrowDown') {
      event.preventDefault();
    }
    if (this.predictiveSearchResults && query.length !== 0) {
      this.predictiveSearchResults.classList.remove('hidden');
    }
  }

  onClearClick(event = null) {
    if (event) event.preventDefault();
    // this.clearButton.classList.add('hidden'); 
    this.input.value = '';
    this.input.focus();
    this.querySelector('#predictive-search-results-groups-wrapper')?.remove();
    this.hideShowPreSearchData('show');
    this.search_drawer.classList.remove('no-result-found');
    this.showRecentSearches();
    if (this.predictiveSearchResults) {
      this.predictiveSearchResults.classList.add('hidden');
    }
    if (this.clearButton) {
      this.clearButton.classList.add('hidden');
    }
    if(!this.dataMainSearch){
      setTimeout(() => {
        trapFocus(this.search_drawer, this.input);
      }, 500);
    }
  }

  getQuery() {
    const searchTerm = this.input.value.trim();
    return searchTerm;
  }

  storeSearchTerm(searchTerm) {
    if (searchTerm.length > 0) {
      let recentSearches = this.getStoredSearchTerms();
      if (!recentSearches.includes(searchTerm)) {
        recentSearches.unshift(searchTerm);
        if (recentSearches.length > 7) {
          recentSearches.pop();
        }
        localStorage.setItem('recentSearchTerms', JSON.stringify(recentSearches));
      }
    }
  }

  getStoredSearchTerms() {
    const recentSearches = localStorage.getItem('recentSearchTerms');
    return recentSearches ? JSON.parse(recentSearches) : [];
  }

  showRecentSearches() {
    const recentSearches = this.getStoredSearchTerms();
    const recentSearch = document.querySelector('[data-recent-searches]');
    const recentSearchContainer = document.querySelector('[data-recent-searches] ul');
    if (recentSearches.length > 0 && recentSearchContainer) {
      recentSearch.classList.remove('hidden');
      recentSearchContainer.innerHTML = '';
      const limitedSearches = recentSearches.slice(0, 7);
      limitedSearches.forEach((searchTerm, index) => {
        const searchItem = this.createSearchItem(searchTerm, index);
        recentSearchContainer.append(searchItem);
      });
      const removeRecentSearch = recentSearchContainer.querySelectorAll('[data-search-value]');
      removeRecentSearch.forEach((search) => {
        search.addEventListener('click', (e) => {
          e.preventDefault();
          let valueToRemove = e.currentTarget.dataset.searchValue;
          let recentSearches = JSON.parse(localStorage.getItem('recentSearchTerms')) || [];
          recentSearches = recentSearches.filter(item => item !== valueToRemove);
          localStorage.setItem('recentSearchTerms', JSON.stringify(recentSearches));
          if (recentSearches.length === 0) {
            document.querySelector('[data-recent-searches]').classList.add('hidden');
          } else if (!recentSearches.includes(valueToRemove)) {
            e.currentTarget.closest('li').remove();
          }
        });
      });
    } else {
      if (recentSearch) {
        document.querySelector('[data-recent-popular-searches]').classList.add('hidden');
      }
    }
  }

  createSearchItem(searchTerm, index) {
    const searchItem = document.createElement('li');
    searchItem.classList.add('recent-search');
    searchItem.id = `predictive-search-category-badge-${index + 1}`;
    const link = document.createElement('a');
    link.href = `/search?q=${searchTerm}`;
    link.classList.add('text-xsmall');
    link.appendChild(document.createTextNode(searchTerm));
    // // Create the SVG element
    // const svgHTML = `
    //   <svg viewBox="0 0 15 15" fill="none">
    //     <path d="M10.8372 4.66285C10.7329 4.55858 10.5914 4.5 10.4439 4.5C10.2964 4.5 10.155 4.55858 10.0507 4.66285L7.5 7.21354L4.9493 4.66285C4.845 4.55858 4.70356 4.5 4.55607 4.5C4.40859 4.5 4.26715 4.55858 4.16285 4.66285C4.05858 4.76715 4 4.90859 4 5.05607C4 5.20356 4.05858 5.345 4.16285 5.4493L6.71354 8L4.16285 10.5507C4.05858 10.655 4 10.7964 4 10.9439C4 11.0914 4.05858 11.2329 4.16285 11.3372C4.26715 11.4414 4.40859 11.5 4.55607 11.5C4.70356 11.5 4.845 11.4414 4.9493 11.3372L7.5 8.78646L10.0507 11.3372C10.155 11.4414 10.2964 11.5 10.4439 11.5C10.5914 11.5 10.7329 11.4414 10.8372 11.3372C10.9414 11.2329 11 11.0914 11 10.9439C11 10.7964 10.9414 10.655 10.8372 10.5507L8.28646 8L10.8372 5.4493C10.9414 5.345 11 5.20356 11 5.05607C11 4.90859 10.9414 4.76715 10.8372 4.66285Z" fill="currentColor"/>
    //   </svg>
    // `;
    // const svgWrapper = document.createElement('div');
    // svgWrapper.classList.add('cross-icon', 'svg-inside');
    // svgWrapper.setAttribute('data-search-value', searchTerm);
    // svgWrapper.innerHTML = svgHTML;
    // link.appendChild(svgWrapper);
    searchItem.appendChild(link);
    return searchItem;
  }
}
customElements.define('predictive-search', PredictiveSearch);

class SearchRecommendation extends HTMLElement {
  constructor() {
    super();
    
    this.section = this.closest('.shopify-section');
    if (!this.section) return;

    const slideElements = this.querySelectorAll('[data-swiper]');
    if (!slideElements.length) return;

    this.initMainSliders = [];

    slideElements.forEach((element) => {
      if (!(element instanceof HTMLElement)) return;
      if (element.offsetParent === null) return; 

      let swiperConfig = {};

      try {
        swiperConfig = element.dataset.swiper
          ? JSON.parse(element.dataset.swiper)
          : {};
      } catch (e) {
        console.warn('Invalid swiper config:', element.dataset.swiper);
        return;
      }

      
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          const swiperInstance = theme.SwiperSlide(element, swiperConfig);

          if (swiperInstance) {
            this.initMainSliders.push(swiperInstance);
          }
        });
      });
    });

  }
}
customElements.define('search-recommendation', SearchRecommendation);

class FeaturedCollectionProducts extends HTMLElement {
  constructor() {
    super();
    this.section = this.closest('.shopify-section');
    const mainslideElements = this.querySelectorAll('[data-swiper]');

    if (!mainslideElements.length) {
      return;
    }

    this.initMainSliders = Array.from(mainslideElements).map((element) => {
      return theme.SwiperSlide(element, JSON.parse(element.dataset.swiper));
    });

  }
  
}
customElements.define('featured-collection-products', FeaturedCollectionProducts);

class CollectionList extends HTMLElement {
  constructor() {
    super();
    this.section = this.closest('.shopify-section');
      if (!this.section) {
      console.warn('<collection-list> is not inside a <section>');
      return;
    }

  }
  
}
customElements.define('collection-list', CollectionList);

class variantChange extends HTMLFieldSetElement {
  constructor() {
    super();
    this.productOptionList = this.querySelector('[data-variant-options]');
    this.productCard = this.closest('[data-product-card]');
    this.init();
  }
  init() {
    if (this.productCard) this.bindVariantImageEvents();
  }

  bindVariantImageEvents() {
    const variantItems = this.productOptionList.querySelectorAll('[data-variant-id]');
    // const featuredImage = this.productCard.querySelector('[data-featured-image]');
    const productMedia = this.productCard.querySelector('secondary-media');
    const template = this.productCard.querySelector('template[data-type="variant-images"]');
    const extractedVariants = new Set();
    variantItems.forEach((item) => {
      item.addEventListener('click', () => {
        const variantId = item.dataset.variantId;
        if (template && !extractedVariants.has(variantId)) {
          const variantImages = template.content.querySelectorAll(`[data-media]`);
          const fragment = document.createDocumentFragment();
          variantImages.forEach((node) => {
            if (!productMedia.querySelector(`[data-media="${node.dataset.media}"]`)) {
              fragment.appendChild(node.cloneNode(true));
              extractedVariants.add(node.dataset.media);
            }
          });
          this.productCard.querySelector('.all-variant-images').appendChild(fragment);
        }

        const selectedImage = this.productCard.querySelector(`[data-media="${variantId}"] img`);
        const activeSlide = this.productCard.querySelector('.swiper-slide-active img');
        if (activeSlide && selectedImage) {
          activeSlide.src = selectedImage.src;
          activeSlide.srcset = selectedImage.srcset;
          activeSlide.alt = selectedImage.alt;
        }
      });
    });
  }
}
customElements.define('variant-change', variantChange, { extends: 'fieldset' });

class MediaGallery extends HTMLElement {
  constructor() {
    super();
    this._initialized = false;
    this.mainSwiper = null;
  }

  connectedCallback() {
    if (!this._initialized) {
      this.init();
    }
    this.addEventListener('lightbox:open', (e) => this.openZoom(e.detail.index || 0));
    window.addEventListener('resize', () => this.handleBreakpointChange());
  }

  disconnectedCallback() {
    if (this.mainSwiper) {
      this.mainSwiper.destroy(true, true);
      this.mainSwiper = null;
    }
  }

  init() {
    this._initialized = true;
    this.handleBreakpointChange();
  }

  initSwiper() {
    const mainEl = this.querySelector('[product-media-gallery]');
    if (!mainEl) return;

    const mainOptions = JSON.parse(mainEl.dataset.swiper || '{}');
    
    setTimeout(() => {
      this.mainSwiper = theme.SwiperSlide(mainEl, mainOptions);
    
      this.mainSwiper.on('slideChangeTransitionEnd', () => {
        const activeSlide = this.mainSwiper.el.querySelector('.swiper-slide-active');
        const activeVideo = activeSlide?.querySelector('video-media, video');
        pauseAllMedia(activeVideo);
      });
    }, 800);
  }

  handleBreakpointChange() {
    const isMobile = window.innerWidth < 768;

    if (isMobile) {
      // Destroy Swiper if exists
      if (this.mainSwiper) {
        this.mainSwiper.destroy(true, true);
        this.mainSwiper = null;
      }
    } else {
      // Desktop: init Swiper if not exists
      if (!this.mainSwiper) this.initSwiper();
    }
  }

  //photoswipe
  get photoswipe() {
    if (this._photoswipe) return this._photoswipe;

    const lightbox = new PhotoSwipeLightbox({
      bgOpacity: 1,
      pswpModule: () => Promise.resolve({ default: PhotoSwipe }),
      allowPanToNext: false,
      allowMouseDrag: true,
      wheelToZoom: false,
      returnFocus: false,
      zoom: false,
      padding: { top: 40, bottom: 40 },
      arrowPrevSVG:
        '<svg class="pswp__icn icon" stroke="currentColor" fill="none" viewBox="0 0 30 30"><path d="M17.5 7.5L10 15L17.5 22.5"/></svg>',
      arrowNextSVG:
        '<svg class="pswp__icn icon" stroke="currentColor" fill="none" viewBox="0 0 30 30"><path d="M17.5 7.5L10 15L17.5 22.5"/></svg>',
      closeSVG:
        '<svg class="pswp__icn icon" stroke="currentColor" fill="none" viewBox="0 0 30 30"><path d="m7.5 22.5 15-15m-15 0 15 15"/></svg>',
    });

    lightbox.addFilter('thumbEl', (thumbEl, data, index) => {
      const baseSlides = this.getBaseSlides(this);
      const img = baseSlides[index]?.querySelector('img');
      return img || thumbEl;
    });

    // If a non-image item is requested, swap in its DOM (video/model)
    lightbox.on('contentLoad', (event) => {
      const { content } = event;
      if (content.data.type && content.data.type !== 'image') {
        event.preventDefault();
        const wrapper = document.createElement('div');
        wrapper.className = 'pswp__embed-container';
        // Use a cloned node to avoid hijacking the real slide
        if (content.data.domElement) wrapper.appendChild(content.data.domElement.cloneNode(true));
        content.element = wrapper;
      }
    });

    // Keep Swiper in sync with PhotoSwipe navigation
    lightbox.on('change', () => {
      const target = lightbox.pswp.currIndex;

      if (this.mainSwiper?.slideToLoop) {
        this.mainSwiper.slideToLoop(target);
      } else if (this.mainSwiper?.slideTo) {
        this.mainSwiper.slideTo(target);
      }

      // Update the current slide's thumb for smooth animation
      const baseSlides = this.getBaseSlides(this);
      const img = baseSlides[target]?.querySelector('img');
      if (img && lightbox.pswp.currSlide?.data) {
        lightbox.pswp.currSlide.data.thumbnailElement = img;
        lightbox.pswp.currSlide.data.thumbCropped = true;
      }
    });

    lightbox.on('contentActivate', ({ content }) => {
      const root = content.element;
      const dm = root?.querySelector('video-media');
      if (dm?.createIntersectionObserver) {
        dm.createIntersectionObserver(); //need to change gurpreet's play media function in video-media
      } else {
        // If plain <video> somehow exists inside
        const v = root?.querySelector('video');
        try {
          v?.play?.();
        } catch (e) { }
      }
    });

    lightbox.on('contentDeactivate', () => {
      pauseAllMedia();
    });

    lightbox.on('close', () => {
      overflowRemove();
    });

    lightbox.init();
    this._photoswipe = lightbox;
    return this._photoswipe;
  }

  openZoom(startIndex = 0) {
    const baseSlides = this.getBaseSlides(this); // stable order 0..N-1
    const items = baseSlides.map((slide) => {
      const type = slide.dataset.mediaType;
      const img = slide.querySelector('img');
      if (type === 'image' && img) {
        const w = parseInt(img.dataset.pswpW || img.getAttribute('width') || img.naturalWidth || 1600, 10);
        const h = parseInt(img.dataset.pswpH || img.getAttribute('height') || img.naturalHeight || 1600, 10);
        return {
          width: w,
          height: h,
          src: img.currentSrc || img.src,
          srcset: img.getAttribute('srcset') || '',
          msrc: img.currentSrc || img.src,
          alt: img.alt || '',
          thumbnailElement: img,
          thumbCropped: true,
        };
      }
      // video, external_video, model
      // const embedEl = slide.querySelector('video-media, product-model');
      const embedEl = slide.querySelector('[data-gallery-item]');
      const ratioStr = slide.querySelector('[data-aspect-ratio]').dataset.aspectRatio;

      // const ratioStr = embedEl?.dataset.aspectRatio || slide.querySelector('.mediabox').style.getPropertyValue('--media-ratio') || '100%';
      const ar = this.parseRatio(ratioStr) || 1;
      const width = 1200;
      const height = Math.max(1, Math.round(width / ar));

      return {
        // Use the real media type so your contentLoad hook runs
        type: type, // 'video' | 'external_video' | 'model'
        domElement: embedEl || slide,
        thumbnailElement: img || slide, // poster img if present
        src: img?.currentSrc || img?.src || '',
        srcset: img?.getAttribute('srcset') || '',
        msrc: img?.currentSrc || img?.src || '',
        width: width,
        height: height,
        alt: img?.alt || '',
        thumbCropped: true,
      };
    });

    let idx = Number.isInteger(startIndex) ? startIndex : null;

    // If we didn't get one, try the active slide's data-index
    if (idx == null) {
      const active = this.querySelector('.swiper-slide-active,[data-media-item].is-active');
      const activeIdx = active ? parseInt(active.getAttribute('data-index'), 10) : null;
      if (Number.isInteger(activeIdx)) idx = activeIdx;
    }

    // Last resort: Swiper's realIndex
    if (idx == null && this.mainSwiper && Number.isInteger(this.mainSwiper.realIndex)) {
      idx = this.mainSwiper.realIndex;
    }

    idx = Math.max(0, Math.min(idx ?? 0, items.length - 1));
    this.photoswipe.loadAndOpen(idx, items);
    overflowAdd();
  }

  getBaseSlides(root) {
    const all = Array.from(root.querySelectorAll('[data-media-item]'));
    // Pick exactly one slide per data-index, ordered by that index
    const bucket = new Map();
    for (const el of all) {
      const k = parseInt(el.getAttribute('data-index'), 10);
      if (!Number.isNaN(k) && !bucket.has(k)) bucket.set(k, el);
    }
    return Array.from(bucket.entries())
      .sort((a, b) => a[0] - b[0])
      .map(([, el]) => el);
  }

  parseRatio(str) {
    if (!str) return 1;
    const s = String(str).trim();
    if (s.includes('/')) {
      const [w, h] = s.split('/').map(Number);
      return w > 0 && h > 0 ? w / h : 1;
    }
    const n = parseFloat(s);
    return isFinite(n) && n > 0 ? n : 1;
  }
}
customElements.define('media-gallery', MediaGallery);

if (!customElements.get('media-lightbox-button')) {
  class MediaLightboxButton extends HTMLButtonElement {
    constructor() {
      super();
      this.addEventListener('click', () => {
        const slideEl = this.closest('[data-media-item]');
        const idxFromData = slideEl ? parseInt(slideEl.getAttribute('data-index'), 10) : null;
        const swIdx = (this.closest('[data-media-item]') || slideEl)?.getAttribute('data-swiper-slide-index');

        this.dispatchEvent(
          new CustomEvent('lightbox:open', {
            bubbles: true,
            detail: {
              index: Number.isInteger(idxFromData) ? idxFromData : null, // ← clicked logical index
              swiperIndex: swIdx != null ? parseInt(swIdx, 10) : null, // optional fallback
            },
          })
        );
      });
    }
  }
  customElements.define('media-lightbox-button', MediaLightboxButton, { extends: 'button' });
}
class ShopLook extends HTMLElement {
  constructor() {
    super();
    this.section = this.closest('.shopify-section');
    this.hotspotContainer = this.section.querySelector('.shop-the-look-media');
    this.hotspots = this.hotspotContainer?.querySelectorAll('.shop-the-look-hotspot') || [];
    this.slides = this.querySelectorAll('.swiper-slide');
    this.init();
    

  }

  init() {
    if (!this.dataset.swiper) return;
    this.initMainSlider = theme.SwiperSlide(this, JSON.parse(this.dataset.swiper));
    this.initMainSlider.on('slideChange', () => {
      const realIndex = this.initMainSlider.realIndex;
      this.updateHotspots(realIndex);
    });

    this.hotspots.forEach((hotspot) => {
      const targetIndex = parseInt(hotspot.dataset.slideIndex, 10);
      hotspot.addEventListener('click', () => {
        this.initMainSlider.slideToLoop(targetIndex);
      });
    });
    
  }

  updateHotspots(index) {
    this.hotspots.forEach((hotspot) => {
      const hotspotIndex = parseInt(hotspot.dataset.slideIndex, 10);
      hotspot.classList.toggle('active', hotspotIndex === index);
    });
  }
}
customElements.define('shop-look', ShopLook);

class ImageComparisonButton extends HTMLElement {
  constructor() {
    super();
    this.button = null;
    this.parentSection = null;
    this._bound = false;

  }

  connectedCallback() {

    if (this._bound) return; // avoid double-binding
    this._bound = true;

    this.button = this.querySelector('[data-comparison-button]');
    if (!this.button) return;

    this.parentSection = this.closest('[data-image-comparison-wrapper]');
    if (!this.parentSection) return;

    this.initComparison();


    if (Shopify.designMode) {
      document.addEventListener('shopify:section:load', (event) => {
        event.target.querySelectorAll('image-comparison-button').forEach((el) => {
          if (el.init) el.initComparison();
        });
      });
    }
  }
 
  initComparison() {
    const button = this.button;
    const parent = this.parentSection;
    const isMobile = window.matchMedia('(max-width: 768px)').matches;
    let isDragging = false;
    let isTouching = false;
    let touchStartX = 0;
    let touchStartY = 0;
    let touchMoved = false;
    let lastTouchTime = 0;

    parent.addEventListener('mousedown', (event) => {
      event.preventDefault();
      isDragging = true;
      parent.classList.add('user-select-none');
    });

    window.addEventListener('mouseup', () => {
      isDragging = false;
      parent.classList.remove('user-select-none');
    });

    parent.addEventListener('click', (event) => {
      // Suppress click triggered by recent touch interaction or while dragging
      if (isDragging || Date.now() - lastTouchTime < 350) return;
      const rect = parent.getBoundingClientRect();
      const deltaX = event.clientX - rect.left;
      const percent = Math.min(Math.max((deltaX / rect.width) * 100, 5), 95);
      parent.style.setProperty('--percent', `${percent}%`);
      button.style.left = `${percent}%`;
    });

    parent.addEventListener(
      'touchstart',
      (event) => {
        isTouching = true;
        isDragging = false;
        touchMoved = false;
        const t = event.touches[0];
        touchStartX = t.clientX;
        touchStartY = t.clientY;
      },
      { passive: true }
    );

    parent.addEventListener(
      'touchmove',
      (event) => {
        const t = event.touches[0];
        const dx = Math.abs(t.clientX - touchStartX);
        const dy = Math.abs(t.clientY - touchStartY);
        const threshold = 5; // px

        if (!touchMoved && (dx > threshold || dy > threshold)) {
          touchMoved = true;
          // Start dragging only if horizontal intent is stronger
          isDragging = dx > dy;
        }

        if (isDragging) {
          // We will control movement; prevent page scroll
          event.preventDefault();
          const rect = parent.getBoundingClientRect();
          const currentX = t.clientX;
          const deltaX = currentX - rect.left;
          const percent = Math.min(Math.max((deltaX / rect.width) * 100, 5), 95);
          parent.style.setProperty('--percent', `${percent}%`);
          button.style.left = `${percent}%`;
        }
        // If not dragging (vertical scroll), do not preventDefault so page can scroll
      },
      { passive: false }
    );

    window.addEventListener(
      'touchend',
      () => {
        isDragging = false;
        if (isTouching) {
          lastTouchTime = Date.now();
        }
        isTouching = false;
      },
      { passive: true }
    );

    parent.addEventListener('mousemove', (event) => {
      if (!isDragging || isMobile) return;
      event.preventDefault();
      const rect = parent.getBoundingClientRect();
      const positionX = event.clientX - rect.left;
      const percent = Math.min(Math.max((positionX / rect.width) * 100, 5), 95);
      parent.style.setProperty('--percent', `${percent}%`);
      button.style.left = `${percent}%`;
    });
  }
}
customElements.define('image-comparison-button', ImageComparisonButton);

window.onYouTubeApiLoaded = new Promise((resolve) => {
  window.onYouTubeIframeAPIReady = resolve;
});
class VideoElement extends HTMLElement {
  constructor() {
    super();
    this._initialized = false;
    this.playerReady = false;
    this.inView = false;
    this.observer = null;
    this.section = this.closest('.shopify-section');

    this.handlePosterClick = this.handlePosterClick.bind(this);
    this.handlePauseClick = this.handlePauseClick.bind(this);

    if (this.posterElement) {
      this.posterElement.addEventListener('click', this.handlePosterClick);
    }

    if (this.posterAnimatedCursorElement) {
      this.posterAnimatedCursorElement.addEventListener('click', this.handlePosterClick);
    }

    if (this.pauseAnimatedCursorElement) {
      this.pauseAnimatedCursorElement.addEventListener('click', this.handlePauseClick);
    }

    const pauseButton = this.querySelector('[data-pause-button]');
    if (pauseButton) {
      pauseButton.addEventListener('click', this.handlePauseClick);
    }

  }
  connectedCallback() {
    this.createIntersectionObserver();
  }

  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
    }
    this.pauseAll();
  }

  static get observedAttributes() {
    return ['playing'];
  }

  get autoplay() {
    return this.hasAttribute('data-autoplay');
  }

  get videoID() {
    return this.getAttribute('data-id');
  }

  get posterElement() {
    return this.querySelector('[id^="Deferred-Poster-"]');
  }

  get posterAnimatedCursorElement() {
    return this.querySelector('[data-poster-animated-cursor-button]');
  }

  get pauseAnimatedCursorElement() {
    return this.querySelector('[data-pause-animated-cursor-button]');
  }

  initializeTemplateContent() {
    if (this._initialized) return;
    this._initialized = true;

    const template = this.querySelector('template');
    if (!template) return;

    const clone = template.content.cloneNode(true);
    template.parentNode.insertBefore(clone, template.nextSibling);

    this.videoElement = this.querySelector('video');
    this.videoIframe = this.querySelector('iframe');

    if (this.videoElement) {
      this.videoElement.addEventListener('play', () => this.setAttribute('playing', ''));
      this.videoElement.addEventListener('pause', () => this.removeAttribute('playing'));
      this.videoElement.addEventListener('ended', () => {
        this.removeAttribute('playing');
        this.toggleButtons(false);
      });
    }
    else if (this.videoIframe) {
      this.initializePlayer(this.videoIframe);
    }
  }

  async initializePlayer(iframe) {
    const script = document.createElement('script');

    if (iframe.src.includes('youtube.com')) {
      if (!window.YT?.Player) {
        script.src = 'https://www.youtube.com/iframe_api';
        document.head.appendChild(script);
        await new Promise(resolve => (script.onload = resolve));
        await window.onYouTubeApiLoaded;
      }

      this.isYouTubePlayer = true;
      this.player = new YT.Player(iframe, {
        videoId: this.videoID,
        events: {
          onReady: event => {
            this.playerReady = true;
            event.target.mute();
            if (this.autoplay && this.inView) this.playYouTube();
          },
          onStateChange: event => {
            if (event.data === YT.PlayerState.PLAYING) {
              this.setAttribute('playing', '');
            } else if ([YT.PlayerState.PAUSED, YT.PlayerState.ENDED].includes(event.data)) {
              this.removeAttribute('playing');
              this.toggleButtons(false);
            }
          }
        }
      });
    }
    else if (iframe.src.includes('vimeo.com')) {
      if (!window.Vimeo?.Player) {
        script.src = 'https://player.vimeo.com/api/player.js';
        document.head.appendChild(script);
        await new Promise(resolve => (script.onload = resolve));
      }

      this.isVimeoPlayer = true;
      this.player = new Vimeo.Player(iframe);

      this.player.ready().then(() => {
        this.playerReady = true;
        if (this.autoplay && this.inView) this.playVimeo();
      });

      this.player.on('play', () => this.setAttribute('playing', ''));
      this.player.on('pause', () => this.removeAttribute('playing'));
      this.player.on('ended', () => {
        this.removeAttribute('playing');
        this.toggleButtons(false);
      });
    }
  }

  createIntersectionObserver() {
    this.observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        this.inView = entry.isIntersecting;

        if (entry.isIntersecting && this.autoplay) {
          VideoElement.stopAllVideos(this);
          this.removePoster();
          this.initializeTemplateContent();

          if (this.videoElement?.paused) {
            this.play();
          } else if (this.isYouTubePlayer && this.playerReady) {
            this.playYouTube();
          } else if (this.isVimeoPlayer && this.playerReady) {
            this.playVimeo();
          }

          this.toggleButtons(true);
        } else {
          this.pauseAll();
        }
      });
    }, { threshold: 0.2 });

    this.observer.observe(this);
  }

  play() {
    this.videoElement?.play?.();
  }

  pause() {
    this.videoElement?.pause?.();
  }

  playYouTube() {
    if (this.isYouTubePlayer && this.playerReady) {
      this.player.playVideo();
    }
  }

  pauseYouTube() {
    if (this.isYouTubePlayer && this.playerReady) {
      this.player.pauseVideo();
    }
  }

  playVimeo() {
    if (this.isVimeoPlayer && this.playerReady) {
      this.player.play();
    }
  }

  pauseVimeo() {
    if (this.isVimeoPlayer && this.playerReady) {
      this.player.pause();
    }
  }

  pauseAll() {
    if (this.isYouTubePlayer) this.pauseYouTube();
    else if (this.isVimeoPlayer) this.pauseVimeo();
    else this.pause();

    this.toggleButtons(false);
  }

  handlePosterClick(event) {
    event.preventDefault();
    event.stopPropagation();

    pauseAllMedia(this); // <-- Add this line

    this.removePoster();
    this.initializeTemplateContent();

    if (this.isYouTubePlayer && this.playerReady) {
      this.playYouTube();
    } else if (this.isVimeoPlayer && this.playerReady) {
      this.playVimeo();
    } else if (this.videoElement) {
      this.play();
    }

    this.toggleButtons(true);
  }
  handlePauseClick(event) {
    event.preventDefault();
    event.stopPropagation();
    this.pauseAll();
  }

  removePoster() {
    const image = this.posterElement?.querySelector('img');
    if (image) {
      image.style.opacity = '0';
      setTimeout(() => image.remove(), 500);
    }
  }

  toggleButtons(isPlaying) {
    const playBtn = this.querySelector('[data-poster-button]');
    const pauseBtn = this.querySelector('[data-pause-button]');

    if (playBtn) playBtn.classList.toggle('hidden', isPlaying);
    if (pauseBtn) pauseBtn.classList.toggle('hidden', !isPlaying);

    const posterAnimatedCursorBtn = this?.querySelector('[data-poster-animated-cursor-button]');
    const pauseAnimatedCursorBtn = this?.querySelector('[data-pause-animated-cursor-button]');

    if (posterAnimatedCursorBtn) posterAnimatedCursorBtn.classList.toggle('hidden', isPlaying);
    if (pauseAnimatedCursorBtn) pauseAnimatedCursorBtn.classList.toggle('hidden', !isPlaying);
  }

  static stopAllVideos(currentVideo) {
    document.querySelectorAll('video-media').forEach(video => {
      if (video !== currentVideo) video.pauseAll();
    });

    document.querySelectorAll('product-model').forEach(model => {
      if (model.modelViewerUI) model.modelViewerUI.pause();
    });
  }
}
customElements.define('video-media', VideoElement);

class QuantityOver extends HTMLElement {
  constructor() {
    super();
    this.handleVolumeprice = this.handleVolumeprice.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  connectedCallback() {
    this.quantity = this.querySelector('[data-quantity-volume]');
    this.closeButton = this.querySelector('[data-close]');
    this.volumePrice = this.querySelector('[data-volume-price]');

    if (this.quantity) {
      this.quantity.addEventListener('click', this.handleVolumeprice);
    }

    if (this.closeButton) {
      this.closeButton.addEventListener('click', this.handleClose);
    }
  }

  handleVolumeprice() {
    if (this.volumePrice && this.volumePrice.hasAttribute('hidden')) {
      this.volumePrice.removeAttribute('hidden');
    }
  }

  handleClose() {
    if (this.volumePrice && !this.volumePrice.hasAttribute('hidden')) {
      this.volumePrice.setAttribute('hidden', '');
    }
  }
}
customElements.define('quantity-over', QuantityOver);

class CountryProvince extends HTMLElement {
  constructor() {
    super();

    // Step 1: Load and render the <template> content
    const template = this.querySelector('template');
    if (!template) {
      return;
    }
    const content = template.content.cloneNode(true);
    this.appendChild(content);

    // Step 2: Now query elements inside the rendered DOM
    this.provinceElement = this.querySelector('[name="address[province]"]');
    this.countryElement = this.querySelector('[name="address[country]"]');

    // Step 3: Set up change listener
    this.countryElement.addEventListener('change', this.CountryChange.bind(this));

    const defaultCountry = this.countryElement.getAttribute('data-default');
    const defaultProvince = this.provinceElement.getAttribute('data-default');

    if (defaultCountry) {
      this.setSelectedOption(this.countryElement, defaultCountry);
    }

    this.CountryChange(defaultProvince);


  }

  setSelectedOption(selectElement, value) {
    const selectedIndex = Array.from(selectElement.options).findIndex(
      (option) => option.value === value
    );
    selectElement.selectedIndex = selectedIndex !== -1 ? selectedIndex : 0;
    selectElement.dispatchEvent(new Event('change', { bubbles: true }));
  }

  CountryChange(defaultProvince = null) {
    const option = this.countryElement.options[this.countryElement.selectedIndex];
    const provinces = JSON.parse(option.dataset.provinces || '[]');

    const shouldHide = provinces.length === 0;
    this.provinceElement.parentElement.hidden = shouldHide;
    this.provinceElement.closest('[data-form-fields]').classList.toggle('hidden', shouldHide);

    this.provinceElement.innerHTML = ''; // Clear previous options

    if (!shouldHide) {
      provinces.forEach(([value, name]) => {
        const selected = defaultProvince ? value === defaultProvince : false;
        this.provinceElement.options.add(new Option(name, value, selected, selected));
      });

      if (defaultProvince) {
        this.setSelectedOption(this.provinceElement, defaultProvince);
      }
    }
  }
}
customElements.define('country-province', CountryProvince);
class ShippingCalculator extends HTMLElement {
  constructor() {
    super(), this._setupCountries();
    this.submitButton = this.querySelector('[type="submit"]');
    this.resultsElement = this.querySelector('[data-shipping-result]');
    this.submitButton.addEventListener('click', this.handleFormSubmit.bind(this));
  }
  handleFormSubmit(event) {
    event.preventDefault();
    const zip = this.querySelector('[name="address[zip]"]').value;
    const country = this.querySelector('[name="address[country]"]').value;
    const province = this.querySelector('[name="address[province]"]').value;
    const body = JSON.stringify({
      shipping_address: {
        zip,
        country,
        province,
      },
    });

    let sectionUrl = `${Theme.routes.cart_url}/shipping_rates.json`;
    sectionUrl = sectionUrl.replace('//', '/');

    fetch(sectionUrl, {
      ...fetchConfig(),
      ...{ body },
    })
      .then((response) => response.json())
      .then((parsedState) => {
        parsedState.shipping_rates
          ? this.formatShippingRates(parsedState.shipping_rates)
          : this.formatError(parsedState);
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        (this.resultsElement.hidden = !1), this.submitButton.removeAttribute('aria-busy');
      });
  }

  formatShippingRates(shippingRates) {
    const shippingRatesList = shippingRates.map((rate) => {
      const { presentment_name, currency, price } = rate;
      return `<span>${presentment_name}: ${currency} ${price}</span>`;

    });

    this.resultsElement.innerHTML = `<div class="form-status body-font text-xsmall success"><div class="form-status-inner">${shippingRatesList.join('')}</div></div>`;
    this.resultsElement.classList.remove('hidden');
  }

  formatError(errors) {
    const errorMessages = Object.values(errors)
      .map((error) => `<div class="cart-form-message">${error}</div>`)
      .join('');
    this.resultsElement.innerHTML = `<div class="form-status body-font text-xsmall error"><div class="form-status-inner"><span class="error-message">${errorMessages}</span></div></div>`;
    this.resultsElement.classList.remove('hidden');
  }

  _setupCountries() {
    if (Shopify && Shopify.CountryProvinceSelector) {
      new Shopify.CountryProvinceSelector('[shippingCountry]', '[shippingProvince]', {
        hideElement: '[shippingProvince]',
      });
    }

    // Load countries from template after DOM is ready
    this.loadCountriesFromTemplate();
  }
  loadCountriesFromTemplate() {
    const countriesDataElement = document.getElementById('countriesData');
    if (!countriesDataElement) return;

    try {
      const countrySelect = this.querySelector('#shippingCountry');

      if (countrySelect && countriesDataElement) {
        // Clear loading message
        countrySelect.innerHTML = '';

        // Clone all option elements from the hidden template
        const optionElements = countriesDataElement.querySelectorAll('option');

        // Add countries from template data
        optionElements.forEach(option => {
          const newOption = option.cloneNode(true);
          countrySelect.appendChild(newOption);
        });

        // Set default country if available
        const defaultCountry = this.querySelector('[data-default]');
        if (defaultCountry) {
          countrySelect.value = defaultCountry.dataset.default;
        }
      }
    } catch (error) {
      console.error('Error loading countries from template:', error);
    }
  }
}
customElements.define('shipping-calculator', ShippingCalculator);
if (!customElements.get('cart-recommendations')) {
  class cartRecommendations extends HTMLElement {
    constructor() {
      super();
      this.section = this.closest('.shopify-section');

    }
    connectedCallback() {
      if (this.querySelector('[data-swiper]')) {
        const element = this.querySelector('[data-swiper]');
        const properties = JSON.parse(element.getAttribute('data-swiper'));
        theme.SwiperSlide(element, properties);
      }

    }
     
  }
  customElements.define('cart-recommendations', cartRecommendations);
}
if (!customElements.get('product-recommendations')) {
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      this.template = null;
      this.productForm = null;
      this.pairsWell = null;
      this.popup = null;
      this.productId = this.getAttribute('product-recommendations-id');
      this.section = this.closest('.shopify-section');
      
    }

    connectedCallback() {
      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((responseText) => {
          const html = document.createElement('div');
          html.innerHTML = responseText;

          const escapedProductId = CSS.escape(parseInt(this.productId));

          const recommendations = html.querySelector(`[product-recommendations-id=${escapedProductId}]`);
          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (this.querySelector('[data-swiper]')) {
            const element = this.querySelector('[data-swiper]');
            const properties = JSON.parse(element.getAttribute('data-swiper'));
            theme.SwiperSlide(element, properties);
          }

          Animations.initAll();


        })
        .catch((error) => {
          console.error('Error fetching recommendations:', error);
        });
    }
  }
  customElements.define('product-recommendations', ProductRecommendations);
}
class RecentlyViewed extends HTMLElement {
  constructor() {
    super();
    this.section = this.closest('.shopify-section');
    const checkrecentlyViewed = window.localStorage.getItem('zyra-recently-viewed');
    if (checkrecentlyViewed != null) {
      this.init();
    } else {
      if (!Shopify.designMode) {
        this.closest('.shopify-section').classList.add('hidden');
      }
    }

  }

  init() {
    const url = this.dataset.section + this.getQueryString();

    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const doc = new DOMParser().parseFromString(responseText, 'text/html');
        const recommendations = doc.querySelector('.shopify-section')?.querySelector('recently-viewed-products');
        const viewedProductsWrapper = doc.querySelector('[data-recent-viewed-products]');
        if (recommendations && viewedProductsWrapper && viewedProductsWrapper.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
          this.closest('.shopify-section').classList.remove('hidden');

          if (this.querySelector('[data-swiper]')) {
            const element = this.querySelector('[data-swiper]');
            const properties = JSON.parse(element.getAttribute('data-swiper'));
            theme.SwiperSlide(element, properties);
          }
        } else {
          if (!Shopify.designMode) {
            this.closest('.shopify-section').classList.add('hidden');
          }
        }
        Animations.initAll();
      })
      .catch((error) => {
        console.error('Error fetching recently viewed products:', error);
        if (!Shopify.designMode) {
          this.closest('.shopify-section').classList.add('hidden');
        }
      });

  }

  getQueryString() {
    const recentlyViewed = window.localStorage.getItem('zyra-recently-viewed') || '[]';
    const items = new Set(JSON.parse(recentlyViewed));

    if (this.dataset.product) {
      items.delete(parseInt(this.dataset.product, 10));
    }

    return Array.from(items, (item) => `id:${item}`)
      .slice(0, parseInt(this.dataset.limit || 15, 10))
      .join(' OR ');
  }
}
customElements.define('recently-viewed-products', RecentlyViewed);
class QuickView extends HTMLButtonElement {
  constructor() {
    super();
    this.init();
    this.selector = '[data-drawer="quickview"]';
    this.drawer = document.querySelector(this.selector);
    if (!this.drawer) return;
  }


  init() {
    this.addEventListener('click', this.onClick.bind(this));
  }
  connectedCallback() {
    this.setupCloseListeners();
  }
  onClick(event) {
    event.preventDefault();
    const getLastClickedElement = document.querySelector('.click-focus-element');
    if(getLastClickedElement){
      getLastClickedElement.classList.remove('click-focus-element');
    }
    this.classList.add('click-focus-element');
    this.querySelector('[data-desktop-text]')?.classList.add('hidden');
    this.querySelector('[data-desktop-button]')?.insertAdjacentHTML('beforeend', `
      <span class="btn-loader" data-btn-loader>
        <span class="svg-inside">
        <svg fill="currentColor" viewBox="0 0 24 24" class="icon-btn-loader">
          <circle cx="4" cy="12" r="3">
          <animate id="spinner_jObz" begin="0;spinner_vwSQ.end-0.25s" attributeName="r" dur="0.75s" values="3;.2;3"/>
          </circle>
          <circle cx="12" cy="12" r="3">
          <animate begin="spinner_jObz.end-0.6s" attributeName="r" dur="0.75s" values="3;.2;3"/>
          </circle>
          <circle cx="20" cy="12" r="3">
          <animate id="spinner_vwSQ" begin="spinner_jObz.end-0.45s" attributeName="r" dur="0.75s" values="3;.2;3"/>
          </circle>
        </svg>
        </span>
      </span>
      `);
    this.fetchProduct();

  }
  setupCloseListeners() {
    if (this.drawer) {
      const closeButtons = [
        this.drawer.querySelector('[data-offcanvas-close]'),
        this.drawer.querySelector('[offcanvas-close]')
      ];

      closeButtons.forEach((btn) => {
        if (btn) {
          btn.addEventListener('click', (e) => {
            e.preventDefault();
            this.close();
          });
        }
      });
      document.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    }

  }

  fetchProduct() {
    const sectionId = this.drawer.dataset.sectionId;
    const sectionUrl = `${this.dataset.productUrl}?section_id=${sectionId}`;

    fetch(sectionUrl)
      .then((response) => response.text())
      .then((responseText) => {
        const productElement = new DOMParser().parseFromString(responseText, 'text/html').querySelector(this.selector);
      

        if (productElement) {

          this.drawerContent = this.drawer.querySelector('[data-quickview-content]');
          this.drawerContent.innerHTML = productElement.querySelector('[data-quickview-content]').innerHTML;
          //Call product-information init
          const productInfoEl = this.drawerContent;
          if (productInfoEl && typeof productInfoEl.init === 'function') {
            productInfoEl.init();
          }

          // Reinitialize Shopify Payment Button (if present)
          if (window.Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }

          // Ensure XR models are registered for the newly injected product
          if (window.ProductModel && typeof window.ProductModel.loadShopifyXR === 'function') {
            window.ProductModel.loadShopifyXR();
          }

          // Bind model poster clicks for newly injected <product-model> elements
          this.drawerContent.querySelectorAll('product-model').forEach((pm) => {
            try {
              const poster = pm.querySelector('[id^="Deferred-model-Poster-"]');
              if (poster) {
                poster.addEventListener('click', pm.loadContent?.bind(pm), { once: true });
              }
            } catch (e) { }
          });

          this.setupCloseListeners();
          this.open();
          const loader = this.querySelector('[data-btn-loader]');
			      if (loader) loader.remove();
          if (this.querySelector('[data-desktop-text]')) {
            this.querySelector('[data-desktop-text]')?.classList.remove('hidden');
          }
        } else {
          console.info('Product element not found in the fetched content.');
        }
      })
      .catch((error) => {
        console.info('Error fetching or parsing product content:', error);
      });
  }

  open() {
    openDrawer('quickview');
    overflowAdd();
    if (this.drawer) {
      setTimeout(() => {
        trapFocus(this.drawer);
      }, 500);
    }
  }
  close() {
    closeDrawer('quickview');
    overflowRemove();
    const getLastClickedElement = document.querySelector('.click-focus-element');
    if(getLastClickedElement){
      getLastClickedElement.focus();
      getLastClickedElement.classList.remove('click-focus-element');
    }
  }
}
customElements.define('quick-view', QuickView, { extends: 'button' });

class QuickViewDrawer extends HTMLElement {
  constructor() {
    super();
    if (Shopify.designMode) {
      document.addEventListener('shopify:section:select', (event) => {
        if (event.target.contains(this)) {
          this.open();
        }
      });

      document.addEventListener('shopify:section:deselect', (event) => {
        if (event.target.contains(this)) {
          this.close();
        }
      });

      document.addEventListener('shopify:section:load', this.showQuickviewButtons);
      document.addEventListener('shopify:section:unload', this.hideQuickviewButtons);


      const closeButtons = [
        this.drawer?.querySelector('[data-offcanvas-close]'),
        this.drawer?.querySelector('[offcanvas-close]')
      ];

      closeButtons.forEach((btn) => {
        if (btn) {
          btn.addEventListener('click', (e) => {
            e.preventDefault();
            this.close();
          });
        }
      });
      // this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    }

  }
  open() {
    openDrawer('quickview');
    overflowAdd();
    const template = this.querySelector('template');

    if (template) {
      const content = template.content.cloneNode(true);
      template.replaceWith(content);
    }
  }
  close() {
    closeDrawer('quickview');
    overflowRemove();
    const getLastClickedElement = document.querySelector('.click-focus-element');
    if(getLastClickedElement){
      getLastClickedElement.focus();
      getLastClickedElement.classList.remove('click-focus-element');
    }
  }

  showQuickviewButtons = () => {
    document.querySelectorAll('.product-quickview').forEach(button => {
      button.classList.remove('hidden');
    });
  };

  hideQuickviewButtons = () => {
    document.querySelectorAll('.product-quickview').forEach(button => {
      button.classList.add('hidden');
    });
  };

  disconnectedCallback() {
    document.removeEventListener('shopify:section:load', this.showQuickviewButtons);
    document.removeEventListener('shopify:section:unload', this.hideQuickviewButtons);
  }
}
customElements.define('quick-view-drawer', QuickViewDrawer);

class LocalizationListbox extends HTMLFormElement {
  constructor() {
    super();

    this.items.forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
  }

  get items() {
    return this._items = this._items || Array.from(this.querySelectorAll('a'));
  }

  get input() {
    return this.querySelector('input[name="locale_code"], input[name="country_code"]');
  }

  onItemClick(event) {
    event.preventDefault();

    this.input.value = event.currentTarget.dataset.value;
    this.submit();
  }
}
customElements.define('localization-listbox', LocalizationListbox, { extends: 'form' });
class ScrollTop extends HTMLElement {
  constructor() {
    super();
    this.currentScrollTop = 0;
    this.BodyScrollTop = 0;
    this.scrollButton = this.querySelector('[back-to-top-button]');

    window.addEventListener('scroll', this.onScroll.bind(this), false);
    this.scrollButton.addEventListener('click', this.onClick.bind(this));
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if (scrollTop > 1000) {
      if (scrollTop > this.currentScrollTop) {
        this.scrollButton.classList.add('show');
      }
    } else {
      this.scrollButton.classList.remove('show');
    }
    this.currentScrollTop = scrollTop;
  }

  onClick() {
    this.smoothScrollToTop();
  }

  smoothScrollToTop() {
    const duration = 700;
    const start = window.pageYOffset;
    const startTime = performance.now();

    const scrollStep = (currentTime) => {
      const timeElapsed = currentTime - startTime;
      const progress = Math.min(timeElapsed / duration, 1);
      const easing = this.easeInOutQuad(progress);

      window.scrollTo(0, start - start * easing);

      if (timeElapsed < duration) {
        requestAnimationFrame(scrollStep);
      }
    };

    requestAnimationFrame(scrollStep);
  }

  // Easing function for smooth scroll animation
  easeInOutQuad(t) {
    return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
  }
}
customElements.define('scroll-top', ScrollTop);
class FeaturedBlogs extends HTMLElement {
  constructor() {
    super();
    this.section = this.closest('.shopify-section');
  }

  connectedCallback() {
    this.init();
    this.bindShopifyEvents();
  }

  init() {
    
    const mainslideElement = this.querySelector('[data-swiper]');
    if (!mainslideElement) return;

    // Destroy existing instance if needed (important for design mode)
    if (this.swiperInstance && this.swiperInstance.destroy) {
      this.swiperInstance.destroy(true, true);
    }

    this.swiperInstance = theme.SwiperSlide(mainslideElement, JSON.parse(mainslideElement.dataset.swiper));
  }

  bindShopifyEvents() {
    // Runs when section is re-rendered in Shopify theme editor
    document.addEventListener('shopify:section:load', (event) => {
      if (event.target.contains(this)) {
        this.init();
      }
    });

    document.addEventListener('shopify:block:select', (event) => {
      if (event.target.closest('featured-blogs') === this) {
        this.init();
      }
    });
  }
}
customElements.define('featured-blogs', FeaturedBlogs);
class HeaderUtilities extends HTMLElement {
  constructor() {
    super();
    this.msgIndex = 0;
    this.charIndex = 1;
    this.mediaQuery = window.matchMedia('(min-width: 1025px)');
    this.section = this.closest('.shopify-section');
  }


  connectedCallback() {
    this.search = this.querySelector('[data-search]');
    this.cart = this.querySelector('[data-cart]');
    this.header = document.querySelector('header');
    this.headerMain = this.header.querySelector('[header-main]');
    this.headerMenuDrawer = document.querySelector('header-hamburger');

    this.drawerMenuButton = this.querySelector('[data-hamburger-button]');
    this.drawerMenuMobileButton = this.querySelector('[data-mobile-drawer-button]');


    this.mediaQuery.addEventListener('change', this.handleMediaChange.bind(this));


    this.checkMenuDrawer();
    if (this.drawerMenuButton) {
      this.drawerMenuButton.addEventListener('click', this.drawerOpen.bind(this));
    }
   
    this.outsideClose();
    
    if (Shopify.designMode) {
      this.observeDesignMode();
    }

    if (this.search) {
      this.search.addEventListener('click', this.searchOpen.bind(this));
      // this.search.addEventListener('focus', this.searchOpen.bind(this));

      if (!this.searchDrawer) return;
      setTimeout(() => {
        this.searchInput = this.searchDrawer.querySelector("[data-search-input]");
        if (!this.searchInput) return;

        this.rawText = this.searchInput.getAttribute("data-typing-texts") || "";
        this.messages = this.rawText.split(',').map(t => t.trim()).filter(t => t.length > 0);

        this.msgIndex = 0;
        this.charIndex = 1;

        if (this.messages.length > 0) {
          this.typeText(); // Start animation after drawer is open and input is ready
        }
      }, 200); // Delay to allow drawer HTML to load (adjust if needed)
    }
  }

  checkMenuDrawer(){
    this.drawerMenuButtonMain = this.querySelector('[data-hamburger-button-wrapper]');
    this.MenuDrawerWrapper = document.querySelector('hamburger-drawer-tabs');

    if(this.drawerMenuButtonMain && this.MenuDrawerWrapper){
      const checkVisibility = this.MenuDrawerWrapper.getAttribute('data-visibility-on');
      if(checkVisibility === 'mobile'){
        this.drawerMenuButtonMain.classList.add('hidden');
      }else{
        this.drawerMenuButtonMain.classList.remove('hidden');
      }
    }else if(this.drawerMenuButtonMain){
      this.drawerMenuButtonMain.classList.add('hidden');
    }

  }

  handleMediaChange(e) {
    if (!e.matches && document.body.classList.contains('hamburger-open')) {
      this.closeHamburgerDrawer();
    }
  }

  typeText() {
    const currentText = this.messages[this.msgIndex];
    this.searchInput.placeholder = currentText.slice(0, this.charIndex);

    if (this.charIndex < currentText.length) {
      this.charIndex++;
      const randomInterval = Math.floor(Math.random() * 200) + 50;
      setTimeout(() => this.typeText(), randomInterval);
    } else {
      setTimeout(() => this.eraseText(), 1500);
    }
  }

  eraseText() {
    this.charIndex--;
    const currentText = this.messages[this.msgIndex];
    this.searchInput.placeholder = currentText.slice(0, this.charIndex);

    if (this.charIndex > 0) {
      setTimeout(() => this.eraseText(), 50);
    } else {
      this.msgIndex = (this.msgIndex + 1) % this.messages.length;
      setTimeout(() => this.typeText(), 1000);
    }
  }

  observeDesignMode() {
    document.addEventListener('shopify:section:select', (event) => {
      if (event.target.querySelector('[data-hamburger-drawer-block]') && document.querySelector('[data-hamburger-button-wrapper]')) {
        if (window.innerWidth >= 1025) {   // ✅ only desktop
          this.openHamburgerDrawer();
        }
      }
    });

    document.addEventListener('shopify:section:deselect', (event) => {
      if (event.target.querySelector('[data-hamburger-drawer-block]') && document.querySelector('[data-hamburger-button-wrapper]')) {
        if (window.innerWidth >= 1025) {   // ✅ only desktop
          this.closeHamburgerDrawer();
        }
      }
    });
  }

  openHamburgerDrawer() {
    const headerMenu = document.querySelector('header-menu');
    if(headerMenu){
      headerMenu.closeAllMenu(); 
    }
    document.body.classList.add('hamburger-open');

  }

  closeHamburgerDrawer() {
    document.body.classList.remove('hamburger-open');
    
    document.querySelectorAll('[data-hamburger-megamenu-item].active').forEach(item => {
      item.classList.remove('active');
    });
  }


  drawerOpen() {

  const headerMenu = document.querySelector('header-menu');
  if (headerMenu) {
    headerMenu.closeAllMenu(); 
  }

  const drawer = document.querySelector('[data-hamburger-nav]');
  let isOpen = document.body.classList.contains('hamburger-open');

  if (isOpen) {
    document.body.classList.remove('hamburger-open');
    this.classList.remove('mobile-menu-open');
  } else {
    document.body.classList.add('hamburger-open');
    this.classList.add('mobile-menu-open');
  }

  // Update the state after toggling
  isOpen = document.body.classList.contains('hamburger-open');

  if (isOpen) {
    overflowAdd();
  } else {
    overflowRemove();
    document.querySelectorAll('[data-hamburger-megamenu-item].active').forEach(item => {
      item.classList.remove('active');
    });
  }

  const checkHamburgerNav = document.querySelector('[data-hamburger-nav]');
  if (checkHamburgerNav) {
    setTimeout(() => {
      trapFocus(checkHamburgerNav);
    }, 500);

    const escHandlerhamburger = (e) => {
      if (e.key === "Escape") {
        this.closeHamburgerDrawer();
        if (this.drawerMenuButton) {
          this.drawerMenuButton.focus();
        }
        document.removeEventListener("keydown", escHandlerhamburger);
      }
    };
    document.addEventListener("keydown", escHandlerhamburger);
  }
}


  searchOpen() {
     if(document.body.classList.contains('hamburger-open')){
    document.body.classList.remove('hamburger-open');
  }
    this.searchDrawer = document.querySelector('[offcanvas-search]');
    if (!this.searchDrawer) return;

    const headerMenu = document.querySelector('header-menu');
    if(headerMenu){
     headerMenu.closeAllMenu(); 
    }
    this.searchDrawer.classList.add('offcanvas-open');

    const template = this.searchDrawer.querySelector('template[data-search-template]');
    if (template) {
      const content = template.content.cloneNode(true);
      template.replaceWith(content);
    }

    setTimeout(() => {
      this.searchInput = this.searchDrawer.querySelector('[data-search-input]');
      if (!this.searchInput) return;
      setTimeout(() => {
        trapFocus(this.searchDrawer, this.searchInput);
      }, 500);
      // this.searchInput.focus();
      overflowAdd();


      this.openerElement = opener || document.querySelector('[data-search]');

      //this.nextFocusableAfterSearch = this.getNextFocusable(this.search);
      this.rawText = this.searchInput.getAttribute('data-typing-texts') || "";
      this.messages = this.rawText.split(',').map(t => t.trim()).filter(t => t.length > 0);

      this.msgIndex = 0;
      this.charIndex = 1;

      if (this.messages.length > 0) {
        this.typeText();
      }

      //this.monitorSearchFocusLoss();
      const escHandler = (e) => {
        if (e.key === "Escape") {
          this.searchClose();
          document.removeEventListener("keydown", escHandler);
        }
      };
      document.addEventListener("keydown", escHandler);
    }, 50);

    Animations.initAll();

  }


  searchClose() {
    if (this.searchDrawer) {
      this.searchDrawer.classList.remove('offcanvas-open');
    }
    overflowRemove();
    setTimeout(() => {
      const getDrawerOpner = document.querySelector('[data-search]');
      if (getDrawerOpner) {
        getDrawerOpner.focus();
      }
    }, 300);
  }
  monitorSearchFocusLoss() {
    if (!this.searchDrawer) return;

    const trapZone = this.searchDrawer;

    const handleFocusOut = (e) => {
      setTimeout(() => {
        const focused = document.activeElement;
        if (!trapZone.contains(focused)) {
          if (this.nextFocusableAfterSearch) {
            this.nextFocusableAfterSearch.focus();
          }
        }
      }, 10);
    };

    trapZone.addEventListener('focusout', handleFocusOut);
  }

  // getNextFocusable(element) {
  //   const focusableSelectors = [
  //     'a[href]', 'button', 'input', 'select', 'textarea',
  //     '[tabindex]:not([tabindex="-1"])'
  //   ];
  //   const focusables = Array.from(document.querySelectorAll(focusableSelectors.join(',')))
  //     .filter(el => !el.disabled && el.offsetParent !== null);

  //   const index = focusables.indexOf(element);
  //   return focusables[index + 1] || null;
  // }

  typeText() {
    const currentText = this.messages[this.msgIndex];
    this.searchInput.placeholder = currentText.slice(0, this.charIndex);

    if (this.charIndex < currentText.length) {
      this.charIndex++;
      const randomInterval = Math.floor(Math.random() * 200) + 50;
      setTimeout(() => this.typeText(), randomInterval);
    } else {
      setTimeout(() => this.eraseText(), 1500);
    }
  }

  eraseText() {
    this.charIndex--;
    const currentText = this.messages[this.msgIndex];
    this.searchInput.placeholder = currentText.slice(0, this.charIndex);

    if (this.charIndex > 0) {
      setTimeout(() => this.eraseText(), 50);
    } else {
      this.msgIndex = (this.msgIndex + 1) % this.messages.length;
      setTimeout(() => this.typeText(), 1000);
    }
  }

  outsideClose() {
    
    this.section.querySelector('[offcanvas-close]').addEventListener('click', (e) => {
      const isOpen = document.body.classList.contains('hamburger-open');
      // More precise: the actual drawer panel
      const drawerPanel = document.querySelector('[data-hamburger-nav]');
      if (this.drawerMenuButton) {
        const clickInsideMenu =
          this.drawerMenuButton.contains(e.target) ||
          (drawerPanel && drawerPanel.contains(e.target));
        if (isOpen && !clickInsideMenu) {
          document.body.classList.remove('hamburger-open');
          overflowRemove();
        }
      }
    });

  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.handleResize);
  }

}
customElements.define('header-utilities', HeaderUtilities);

class NewsletterPopup extends HTMLElement {
  constructor() {
    super();
    this.newsletterDisplayMode = this.dataset.newsletterDisplayMode;
    this.showHomepage = this.dataset.showHomepage === 'true';
    this.template = this.dataset.template;
    this.disableForAccountHolders = this.dataset.disableForAccountHolders === 'true';
    this.loginCustomerId = this.dataset.loginCustomerid;
    this.newsletterPopupDelay = this.dataset.newsletterPopupDelay;
    this.selector = '[data-drawer="newsletter-popup"]';
    this.drawer = document.querySelector(this.selector);

    // Get visitors flag + days from hidden input
    this.visitorsOnly = this.querySelector('[name="newsletterCookieValue"]')?.dataset.visitors === "true";
    this.cookieDaysInput = this.querySelector('[name="newsletterCookieValue"]')?.value || 7;
    if (!this.drawer) return;
  }

  connectedCallback() {
    if (Shopify.designMode) {
      document.addEventListener('shopify:section:select', (event) => {
        if (event.target.contains(this)) {
          this.open();
        }
      });

      document.addEventListener('shopify:section:deselect', (event) => {
        if (event.target.contains(this)) {
          this.close();
        }
      });
    }

    const hasAgePopup = document.querySelector('age-verification');
    const ageVerified = this.getCookie('is_age_verified') === 'age_verified';
    
    if (!hasAgePopup || ageVerified || hasAgePopup.dataset.ageVerificationDisplayMode == 'test_mode') {
      this.init();
    } else {
      document.addEventListener('ageVerified', () => {
        this.init();
      }, { once: true });
    }

    this.setupCloseListeners();
  }

  init() {
    const get_cookie_value = this.getCookie('is_newsletter_popup_closed');

    if (!Shopify.designMode && this.newsletterDisplayMode == 'enable') {
      let show_newsletter_popup = true;
      if (this.showHomepage === true && this.template != 'index') {
        show_newsletter_popup = false;
      }
      if (this.disableForAccountHolders && this.loginCustomerId != '') {
        show_newsletter_popup = false;
      }

      if (show_newsletter_popup) {
        if (get_cookie_value !== 'newsletter_popup_closed' && window.location.pathname.indexOf('/challenge') < 0) {
          setTimeout(() => {
            localStorage.setItem('theme:popup-filled', 'false');
            this.classList.add('offcanvas-open');
            setTimeout(() => this.classList.add('show-image'), 500);
            setTimeout(() => trapFocus(this), 500);
          }, `${this.newsletterPopupDelay}000`);
        }
      }
    }

    // If subscribed successfully
    if (localStorage.getItem('theme:popup-filled') === 'true') {
      if (get_cookie_value !== 'newsletter_popup_closed') {
        let expireDays = this.visitorsOnly ? 30 : parseInt(this.cookieDaysInput) || 7;
        this.setCookieValue('is_newsletter_popup_closed', 'newsletter_popup_closed', expireDays);
        this.classList.remove('offcanvas-open');
      }
    }
  }

  setupCloseListeners() {
    const closeButtons = [
      this.drawer.querySelector('[data-offcanvas-close]'),
      this.drawer.querySelector('[offcanvas-close]'),
    ];

    closeButtons.forEach((btn) => {
      if (btn) {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          this.close();
        });
      }
    });
  }

  open() {
    this.classList.add('offcanvas-open');
    setTimeout(() => this.classList.add('show-image'), 500);
    setTimeout(() => trapFocus(this), 500);
  }

  close() {
    this.classList.remove('offcanvas-open');

    // If visitorsOnly = true → set cookie immediately on close
    if (this.visitorsOnly) {
      this.setCookieValue('is_newsletter_popup_closed', 'newsletter_popup_closed', 30);

      // Also update localStorage so popup doesn't re-trigger
      localStorage.setItem('theme:popup-filled', 'true');
    }
  }

  getCookie(name) {
    let cname = name + '=';
    let decodedCookie = decodeURIComponent(document.cookie);
    let cookies = decodedCookie.split(';');
    for (let c of cookies) {
      c = c.trim();
      if (c.indexOf(cname) === 0) {
        return c.substring(cname.length, c.length);
      }
    }
    return '';
  }

  setCookieValue(name, value, expireDays) {
    let d = new Date();
    d.setTime(d.getTime() + parseInt(expireDays) * 24 * 60 * 60 * 1000);
    let expires = 'expires=' + d.toUTCString();
    document.cookie = name + '=' + value + ';' + expires + ';path=/';
  }
}
customElements.define('newsletter-popup', NewsletterPopup);

class ageVerifier extends HTMLElement {
  constructor() {
    super();
    this.ageVerificationDisplayMode = this.dataset.ageVerificationDisplayMode;
    this.submit_btn = this.querySelector('[data-submit-age]');
    this.cookietime = this.dataset.cookieDate;
    this.submit_btn.addEventListener('click', this.ageSubmitted.bind(this));
  }

  connectedCallback() {
    if (Shopify.designMode && this.designMode) {
      const section = this.closest('.shopify-section');
      section.addEventListener('shopify:section:select', (event) => this.open());
      section.addEventListener('shopify:section:deselect', this.close());
    }
    // if (Shopify.designMode) {
    //   document.addEventListener('shopify:section:select', (event) => {
    //     if (event.target.contains(this)) {
    //       this.open();
    //     }
    //   });

    //   document.addEventListener('shopify:section:deselect', (event) => {
    //     if (event.target.contains(this)) {
    //       this.close();
    //     }
    //   });
    // }
    this.init();
  }

  init() {
    var age_Pop = this.getCookie('is_age_verified');
    if (!Shopify.designMode && this.ageVerificationDisplayMode == 'enable') {
      if (age_Pop != 'age_verified' && window.location.pathname.indexOf('/challenge') < 0) {
        this.classList.add('offcanvas-open');
        document.body.classList.add('overflow-hidden');
        setTimeout(() => {
          trapFocus(this);
        }, 500);
      }
    }
  }

  open() {
    this.classList.add('offcanvas-open');
    document.body.classList.add('overflow-hidden');
    setTimeout(() => {
      trapFocus(this);
    }, 500);

  }

  close() {
    this.classList.remove('offcanvas-open');
    document.body.classList.remove('overflow-hidden');
  }

  ageSubmitted() {
    this.classList.remove('offcanvas-open');
    document.body.classList.remove('overflow-hidden');
    var date = new Date();
    date.setTime(date.getTime() + parseInt(this.cookietime) * 24 * 60 * 60 * 1000);
    this.setCookieValue('is_age_verified', 'age_verified', this.cookietime);
    document.dispatchEvent(new CustomEvent('ageVerified', { detail: { verified: true } }));
  }

  get designMode() {
    return this.hasAttribute('shopify-design-mode');
  }

  getCookie(name) {
    let cname = name + '=';
    let decodedCookie = decodeURIComponent(document.cookie);
    let cookies = decodedCookie.split(';');
    for (let c of cookies) {
      c = c.trim();
      if (c.indexOf(cname) === 0) {
        return c.substring(cname.length, c.length);
      }
    }
    return '';
  }

  setCookieValue(name, value, expireDays) {
    let d = new Date();
    d.setTime(d.getTime() + parseInt(expireDays) * 24 * 60 * 60 * 1000);
    let expires = 'expires=' + d.toUTCString();
    document.cookie = name + '=' + value + ';' + expires + ';path=/';
  }
}
customElements.define('age-verification', ageVerifier);

class HeaderMenu extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.headerNavigation();
    this.dropDownMenuPositions();
    window.addEventListener('resize', this.dropDownMenuPositions.bind(this));
  }
  closeAllMenu(){
      const megaMenuLinks = this.querySelectorAll('[data-megamenu], [data-submenu]');
      const headerSection = this.closest('.shopify-section');
      const headerMain = headerSection ? headerSection.querySelector('[header-main]') : null;

      this.querySelectorAll('[data-nav-item].active').forEach(menu => menu.classList.remove('active'));
      megaMenuLinks.forEach(link => link.classList.remove('active'));
      if (headerMain) {
        headerMain.classList.remove('megamenu-open');
        overflowRemove();
      }
  }
  headerNavigation() {
    this.openOn = this.dataset.openDropdownItem;
    const megaMenuLinks = this.querySelectorAll('[data-megamenu], [data-submenu]');
    const headerSection = this.closest('.shopify-section');
    const headerMain = headerSection ? headerSection.querySelector('[header-main]') : null;

    const closeMenu = () => {

      this.querySelectorAll('[data-nav-item].active').forEach(menu => menu.classList.remove('active'));
      megaMenuLinks.forEach(link => link.classList.remove('active'));
      if (headerMain) {
        headerMain.classList.remove('megamenu-open');
        overflowRemove();
      }

    };

    const openMenu = (link) => {
      const clickedMenu = link.closest('[data-nav-item]');
      const isAlreadyActive = clickedMenu.classList.contains('active') && link.classList.contains('active');

      if (isAlreadyActive) {
        closeMenu();
        return;
      }

      closeMenu();
      clickedMenu.classList.add('active');
      link.classList.add('active');

      if (headerMain) {
        headerMain.classList.add('megamenu-open');
      }
      overflowAdd();
    };

    // Always enable click and keyboard open/close
    megaMenuLinks.forEach(link => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        openMenu(link);
      });
      link.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          openMenu(link);
        }
      });
    });

    // Add hover behaviors only when configured
    if (this.openOn === 'hover') {
      let openTimeout, closeTimeout;
      let currentActiveMenu = null;

      megaMenuLinks.forEach(link => {
        const parentItem = link.closest('[data-nav-item]');
        // Find the submenu container (megamenu-wrap or submenu-wrap)
        const submenuContainer = parentItem.querySelector('.megamenu-wrap, .submenu-wrap');
        
        // Combined hover area handler
        const handleMouseEnter = () => {
          clearTimeout(closeTimeout);
          if (currentActiveMenu !== link) {
            clearTimeout(openTimeout);
            openTimeout = setTimeout(() => {
              openMenu(link);
              currentActiveMenu = link;
            }, 300);
          }
        };

        const handleMouseLeave = (e) => {
          clearTimeout(openTimeout);
          
          // Check if mouse is moving to the submenu or parent item
          const relatedTarget = e.relatedTarget;
          if (!relatedTarget) {
            closeTimeout = setTimeout(() => {
              closeMenu();
              currentActiveMenu = null;
            }, 300);
            return;
          }

          // Check if mouse is moving to parent item, submenu, or any child element
          const isMovingToParent = parentItem.contains(relatedTarget);
          const isMovingToSubmenu = submenuContainer && submenuContainer.contains(relatedTarget);
          const isMovingToChild = parentItem.querySelector('.megamenu-wrap, .submenu-wrap')?.contains(relatedTarget);
          
          // Only close if mouse is not moving to any part of the menu
          if (!isMovingToParent && !isMovingToSubmenu && !isMovingToChild) {
            closeTimeout = setTimeout(() => {
              closeMenu();
              currentActiveMenu = null;
            }, 300);
          }
        };

        // Attach listeners to parent item
        parentItem.addEventListener('mouseenter', handleMouseEnter);
        parentItem.addEventListener('mouseleave', handleMouseLeave);

        // Attach listeners to submenu container if it exists
        if (submenuContainer) {
          submenuContainer.addEventListener('mouseenter', handleMouseEnter);
          submenuContainer.addEventListener('mouseleave', handleMouseLeave);
        }
      });
    }

    document.addEventListener('click', (event) => {
      const target = event.target;
       
      // Only react if this header's megamenu is currently open
      const isMenuOpen = !!(
        (headerMain && headerMain.classList.contains('megamenu-open')) ||
        this.querySelector('[data-nav-item].active')
      );
      if (!isMenuOpen) return;

      // Close only when clicking this component's own overlay
      const localOverlay = this.closest('header')?.querySelector?.('[offcanvas-close]');
      if (localOverlay && (target === localOverlay || localOverlay.contains(target))) {
        closeMenu();
        return;
      }

      const insideHeaderMenu = this.contains(target);
      const insideHeaderMain = headerMain ? headerMain.contains(target) : false;
      const insidePanels = !!(
        target.closest('[data-nav-item], [data-megamenu], [data-submenu], .submenu-wrap, .submenus, [data-megamenu-panel], [data-submenu-panel], .mega-menu, .megamenu, [data-menu-drawer]')
      );

      if (!(insideHeaderMenu || insideHeaderMain || insidePanels)) {
        closeMenu();
      }
    });
  }

  dropDownMenuPositions() {

    const windowSize = window.innerWidth;
    const rects = this.querySelectorAll('[data-nav-item]');

    rects.forEach(el => {
      el.classList.remove('menu-position-left');
      el.style.removeProperty('--dropdown-parent--width');

    });

    rects.forEach(menus => {
      const rect = menus.getBoundingClientRect();
      let currentPosition = rect.left + rect.width;

      const grandChildList = menus.querySelector(".submenu-wrap");
      if (grandChildList) {
        currentPosition += grandChildList.getBoundingClientRect().width;
      }
      if (currentPosition >= windowSize) {
        menus.style.setProperty(
          '--dropdown-parent--width',
          `${rect.width}px`
        );
        menus.classList.add("menu-position-left");
      }
    });
  }
}
customElements.define('header-menu', HeaderMenu);
if (!customElements.get('highlighted-products-tabs')) {
  class HighlightedProductsTabs extends HTMLElement {
    constructor() {
      super();

      this.section = this.closest('.shopify-section');
      this.tabs = this.querySelectorAll('button[data-tab]'); //its id is combined with block id
      this.sliderWrappers = this.querySelectorAll('[data-sliders]'); //its id is combined with block id
      this.sliders = this.querySelectorAll('[data-swiper]');

      this.mainImages = this.querySelectorAll('[data-main-image]'); //its id is combined with product id and block id
      this.productCards = this.querySelectorAll('[data-product-card]'); //its id is combined with product id and block id
      this.productOtherImages = this.querySelectorAll('[data-other-images]'); //its id is combined with product id and block id
      this.mediacontentWrapper = this.querySelector('[data-media-content-wrapper]');
      this.mmainImageWrapper = this.querySelector('[data-main-images-wrapper]');


    }

    connectedCallback() {
      this.init();
      this.bindEvents();
      this.activateInitialState();
      // Shopify design mode reinit support
      if (Shopify && Shopify.designMode) {
        document.addEventListener('shopify:section:load', (e) => { });
        document.addEventListener('shopify:block:select', (e) => { });
        document.addEventListener('shopify:block:deselect', (e) => { });
      }

      const updateMediaHeight = () => {
        this.mediacontentWrapper.style.setProperty(
          '--highlighted-product-media-height',
          `${this.mmainImageWrapper.getBoundingClientRect().height}px`
        );
      };
      updateMediaHeight();
      // Update the variable on window resize
      if (!this._mediaHeightResizeHandler) {
        this._mediaHeightResizeHandler = updateMediaHeight.bind(this);
        window.addEventListener('resize', this._mediaHeightResizeHandler);
      }
    }

    init() {
      if (this.sliders) {
        this.swiperByElement = new Map();
        this.initSliders = Array.from(this.sliders).map((element) => {
          const instance = theme.SwiperSlide(element, JSON.parse(element.dataset.swiper));
          this.swiperByElement.set(element, instance);
          const updateFromInstance = () => {
            const wrapper = element.closest('[data-sliders]');
            if (!wrapper || !wrapper.classList.contains('active')) return;
            const slides = instance.slides || element.querySelectorAll('.swiper-slide');
            const activeIndex = typeof instance.activeIndex === 'number' ? instance.activeIndex : 0;
            const activeSlide = slides && slides[activeIndex] ? slides[activeIndex] : element.querySelector('.swiper-slide-active');
            const key = this.getKeyFromSlide(activeSlide);
            if (key) {
              this.updateActiveByKey(key);
            }
          };
          
          instance.on('tap', (swiper, evt) => {
            const clickedSlide = evt.target && evt.target.closest ? evt.target.closest('.swiper-slide') : null;
            if (!clickedSlide || !element.contains(clickedSlide)) return;

            const realIndexAttr = clickedSlide.getAttribute('data-swiper-slide-index');
            const realIndex = realIndexAttr != null ? parseInt(realIndexAttr, 10) : NaN;

            if (!Number.isNaN(realIndex) && typeof instance.slideToLoop === 'function') {
              instance.slideToLoop(realIndex, 400);
            } else if (typeof instance.slideTo === 'function') {
              const slides = Array.from(element.querySelectorAll('.swiper-slide'));
              const clickedIndex = slides.indexOf(clickedSlide);
              if (clickedIndex >= 0) instance.slideTo(clickedIndex, 400);
            }

            const key = this.getKeyFromSlide(clickedSlide);
            if (key) {
              this.updateActiveByKey(key);
            }
          });

          // React to multiple events to be robust with navigation and looping
          instance.on('activeIndexChange', updateFromInstance);
          instance.on('realIndexChange', updateFromInstance);
          instance.on('slideChangeTransitionEnd', updateFromInstance);
          return instance;
        });
      }
    }

    bindEvents() {
      if (!this.tabs || !this.tabs.length) return;
      this.tabs.forEach((tab) => {
        tab.addEventListener('click', (event) => {
          event.preventDefault();
          const groupId = tab.dataset.tab;
          if (!groupId) return;
          this.activateTab(groupId, tab);
        });
      });
    }

    activateInitialState() {
      const activeTab = Array.from(this.tabs || []).find((t) => t.classList.contains('active')) || (this.tabs && this.tabs[0]);
      if (!activeTab) return;
      const groupId = activeTab.dataset.tab;
      this.activateTab(groupId, activeTab, { focus: false });
    }

    activateTab(groupId, tab, options = {}) {
      const { focus = true } = options;
      // Update tab active state
      (this.tabs || []).forEach((t) => {
        const isActive = t === tab;
        t.classList.toggle('active', isActive);
        t.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      // Show/Hide slider wrappers
      (this.sliderWrappers || []).forEach((wrapper) => {
        const isMatch = wrapper.dataset && wrapper.dataset.sliders === groupId;
        wrapper.classList.toggle('active', isMatch);
        wrapper.classList.toggle('hidden', !isMatch);
      });

      // Find the slider within the active wrapper
      const activeWrapper = Array.from(this.sliderWrappers || []).find((w) => w.dataset && w.dataset.sliders === groupId);
      if (!activeWrapper) return;

      const sliderEl = activeWrapper.querySelector('[data-swiper]');
      const swiper = sliderEl ? this.swiperByElement && this.swiperByElement.get(sliderEl) : null;

      // Do not force movement; just read the current active slide
      const slides = (swiper && swiper.slides) || (sliderEl && sliderEl.querySelectorAll('.swiper-slide'));
      const activeIndex = swiper && typeof swiper.activeIndex === 'number' ? swiper.activeIndex : 0;
      const activeSlide = slides && slides[activeIndex] ? slides[activeIndex] : (sliderEl && sliderEl.querySelector('.swiper-slide-active'));
      const key = this.getKeyFromSlide(activeSlide);
      if (groupId && key) {
        this.updateActiveByKey(key);
      }

      if (focus && typeof tab.focus === 'function') {
        tab.focus();
      }
    }

    getSlideInfo(sliderElement, index) {
      if (!sliderElement) return { productId: null, blockId: null };
      const slides = sliderElement.querySelectorAll('.swiper-slide');
      const slide = slides && slides[index] ? slides[index] : null;
      if (!slide) return { productId: null, blockId: null };

      // Prefer explicit data attributes
      const productId = slide.dataset.product || slide.getAttribute('data-product');
      const blockId = slide.dataset.block || slide.getAttribute('data-block');
      return { productId, blockId };
    }

    extractIdFromAny(element, keyword) {
      // Fallback: search all data-* attributes for a value containing the keyword
      const dataset = element.dataset || {};
      for (const key in dataset) {
        if (!Object.prototype.hasOwnProperty.call(dataset, key)) continue;
        const value = dataset[key];
        if (typeof value === 'string' && value && (key.toLowerCase().includes(keyword) || value.toLowerCase().includes(keyword))) {
          return value;
        }
      }
      return null;
    }

    updateActiveProductViews(groupId, productId) {
      const key = `${productId}-${groupId}`;
      this.updateActiveByKey(key);
    }

    updateActiveByKey(key) {
      this.toggleActiveOnly(this.mainImages, 'mainImage', key);
      this.toggleActiveWithHidden(this.productCards, 'productCard', key);
      // this.toggleActiveWithHidden(this.productOtherImages, 'otherImages', key);
      this.toggleActiveWithHiddenAndAnimate(this.productOtherImages, 'otherImages', key);
    }

    toggleActiveOnly(nodeList, dataKey, desired) {
      if (!nodeList) return;
      Array.from(nodeList).forEach((el) => {
        const value = el.dataset && el.dataset[dataKey];
        const matches = value === desired;
        el.classList.toggle('active', matches);
      });
    }

    toggleActiveWithHidden(nodeList, dataKey, desired) {
      if (!nodeList) return;
      Array.from(nodeList).forEach((el) => {
        const value = el.dataset && el.dataset[dataKey];
        const matches = value === desired;
        el.classList.toggle('active', matches);
        el.classList.toggle('hidden', !matches);
      });
    }

    toggleActiveWithHiddenAndAnimate(nodeList, dataKey, desired) {
      if (!nodeList) return;
      let hasMatch = false;
      Array.from(nodeList).forEach((el) => {
        const value = el.dataset && el.dataset[dataKey];
        const shouldActivate = value === desired;

        // clear any prior animate delay
        if (el.__otherImgTimer) {
          clearTimeout(el.__otherImgTimer);
          el.__otherImgTimer = null;
        }
        if (shouldActivate) {
          hasMatch = true;
          el.classList.remove('hidden');
          el.classList.add('active');
          el.__otherImgTimer = setTimeout(() => {
            el.classList.add('animate');
            el.__otherImgTimer = null;
          }, 150);
        } else {
          el.classList.remove('animate');
          el.classList.remove('active');
          el.classList.add('hidden');
        }
      });

      if(this.mediacontentWrapper){
        if (!hasMatch) {
          this.mediacontentWrapper.classList.add('without-thumbnail-product');
        } else {
          this.mediacontentWrapper.classList.remove('without-thumbnail-product');
        }
      }
    }

    getKeyFromSlide(slide) {
      if (!slide) return null;
      const product = slide.dataset && (slide.dataset.product || slide.getAttribute('data-product'));
      const block = slide.dataset && (slide.dataset.block || slide.getAttribute('data-block'));
      if (!product || !block) return null;
      return `${product}-${block}`;
    }

    elementMatchesGroupAndProduct(el, groupId, productId) {
      // Preferred explicit attributes
      const elProductId = el.dataset.productId || el.getAttribute('data-product-id');
      const elBlockId = el.dataset.blockId || el.getAttribute('data-block-id');
      if (elProductId && elBlockId) {
        return elProductId == productId && elBlockId == groupId;
      }

      // Combined id in specific data key (e.g., data-main-image="{groupId}-{productId}")
      const combinedKeys = ['mainImage', 'productCard', 'otherImages'];
      for (const key of combinedKeys) {
        const value = el.dataset[key];
        if (typeof value === 'string' && value) {
          if (value.includes(groupId) && value.includes(productId)) return true;
        }
      }

      // Fallback: scan all data-* values
      for (const key in el.dataset) {
        if (!Object.prototype.hasOwnProperty.call(el.dataset, key)) continue;
        const value = el.dataset[key];
        if (typeof value === 'string' && value && value.includes(groupId) && value.includes(productId)) {
          return true;
        }
      }
      return false;
    }
  }
  customElements.define('highlighted-products-tabs', HighlightedProductsTabs);
}

class CollectionLists extends HTMLElement {
    constructor() {
      super();
      this.section = this.closest('.shopify-section');
      this.items = this.querySelectorAll('[data-collection-item]');
      this.products = this.section.querySelectorAll('[data-collection-products]');

      if (this.items.length > 0) {
        this.items[0].classList.add('active');
      }
      if (this.products.length > 0) {
        this.products.forEach((el, i) => {
          if (i === 0) {
            el.classList.add('active');
            el.classList.remove('hidden');
          } else {
            el.classList.add('hidden');
          }
        });
      }

      this.items.forEach((tab) => {
        tab.addEventListener('click', () => this.toggleTab(tab));

        tab.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault(); // prevent page scroll when pressing Space
            this.toggleTab(tab);
          }
        });
      });

      //this.setupScrollPrevention();
    }
  

    toggleTab(tab) {
      const targetId = tab.getAttribute('id');
      const targetContent = this.section.querySelector(`[data-collection-products="${targetId}"]`);
      if (!targetContent) return;

      if (tab.classList.contains('active')) return;

      this.items.forEach((t) => t.classList.remove('active'));
      this.products.forEach((p) => {
        p.classList.remove('active');
        p.classList.add('hidden');
      });

      tab.classList.add('active');
      targetContent.classList.remove('hidden');
      targetContent.classList.add('active');

      this.init();
    }
  }

  customElements.define('xs-collection-lists', CollectionLists);

class HamburgerDrawerTabs extends HTMLElement {
  connectedCallback() {
    const announcementBar = document.querySelector('.announcement-section');
    if (announcementBar) {
      const height = announcementBar.getBoundingClientRect().height;
      document.body.style.setProperty('--announcement-height', `${height}px`);
    } else {
      document.body.style.setProperty('--announcement-height', `0px`);
    }

    // Check header presence and manage hamburger drawer visibility
    this.checkHeaderPresence();
    
    // Listen for theme editor events
    if (Shopify.designMode) {
      this.setupThemeEditorEvents();
    }
    // Tab switching logic
    this.querySelectorAll('[data-main-hamburger]').forEach(tabsContainer => {
      const tabButtons = tabsContainer.querySelectorAll('[data-link-hamburger]');
      const tabContents = tabsContainer.querySelectorAll('[data-block-hamburger]');

      tabButtons.forEach(button => {
        button.addEventListener('click', (e) => {
          e.preventDefault();
          const targetId = button.getAttribute('data-tab');
          const targetContent = tabsContainer.querySelector(`#${targetId}`);
          if (!targetContent) return;

          tabButtons.forEach(btn => btn.classList.remove('active'));
          tabContents.forEach(content => {
            content.classList.remove('active');
            if (!content.innerHTML.trim()) {
              content.classList.add('no-subdata');
            } else {
              content.classList.remove('no-subdata');
            }
          });

          button.classList.add('active');
          targetContent.classList.add('active');
        });

        button.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            button.click();
          }
        });
      });
    });

    // Global click logic for hamburger navigation/back
    document.addEventListener('click', (e) => {
      const navLink = e.target.closest('[data-nav-hamburger-link]');
      const backButton = e.target.closest('[data-hamburger-back]');

      if (navLink) {
        const mainParent = navLink.closest('[data-hamburger-nav]');
        const parent = navLink.closest('[data-hamburger-megamenu-item]');
        const siblings = parent?.parentElement?.querySelectorAll('[data-hamburger-megamenu-item]');
        if (mainParent && parent && siblings) {
          mainParent.classList.add('hamburger-megamenu-menus-open');
          siblings.forEach(item => item.classList.remove('active'));
          parent.classList.add('active');
          const getInnerWrapper = parent.querySelector('.hamburger-megamenus-menuswrap');
            if(getInnerWrapper){
              setTimeout(() => {
                const focusElement = getInnerWrapper.querySelector('[data-hamburger-back]');
                trapFocus(getInnerWrapper, focusElement);
            }, 300);
          }
        }
      }

      if (backButton) {
        const closestMainParent = backButton.closest('[data-hamburger-megamenu-item]');
        const mainParent = backButton.closest('[data-hamburger-nav]');
        document.querySelectorAll('[data-hamburger-megamenu-item].active').forEach(item => {
          item.classList.remove('active');
        });

        if (mainParent) {
          mainParent.classList.remove('hamburger-megamenu-menus-open');
          setTimeout(() => {
            const mainfocusElement = closestMainParent.querySelector('[data-nav-hamburger-link]');
            trapFocus(mainParent, mainfocusElement);
          }, 300);
        }

      }
    });
  }

  // Check if header element is present and manage hamburger drawer visibility
  checkHeaderPresence() {
    const header = document.querySelector('header');
    const hamburgerDrawerTabs = document.querySelector('hamburger-drawer-tabs');

    if (!header) {
      // Header not present, add hidden class
      if (hamburgerDrawerTabs) {
        hamburgerDrawerTabs.classList.add('hidden');
      }
    } else {
      // Header present, remove hidden class
      if (hamburgerDrawerTabs) {
        hamburgerDrawerTabs.classList.remove('hidden');
      }
    }
  }
  

  // Setup theme editor event listeners
  setupThemeEditorEvents() {
    // Listen for section load/unload events (header section changes)
    document.addEventListener('shopify:section:load', (event) => {
      if (event.detail.sectionId.includes('header') || event.detail.sectionId.includes('header-group')) {
        setTimeout(() => this.checkHeaderPresence(), 100);
      }
    });

    document.addEventListener('shopify:section:unload', (event) => {
      if (event.detail.sectionId.includes('header') || event.detail.sectionId.includes('header-group')) {
        setTimeout(() => this.checkHeaderPresence(), 100);
      }
    });

    // Listen for section select/deselect events
    document.addEventListener('shopify:section:select', (event) => {
      if (event.detail.sectionId.includes('header') || event.detail.sectionId.includes('header-group')) {
        setTimeout(() => this.checkHeaderPresence(), 100);
      }
    });

    document.addEventListener('shopify:section:deselect', (event) => {
      if (event.detail.sectionId.includes('header') || event.detail.sectionId.includes('header-group')) {
        setTimeout(() => this.checkHeaderPresence(), 100);
      }
    });

    // Listen for block events within header sections
    document.addEventListener('shopify:block:select', (event) => {
      if (event.detail.sectionId.includes('header') || event.detail.sectionId.includes('header-group')) {
        setTimeout(() => this.checkHeaderPresence(), 100);
      }
    });

    document.addEventListener('shopify:block:deselect', (event) => {
      if (event.detail.sectionId.includes('header') || event.detail.sectionId.includes('header-group')) {
        setTimeout(() => this.checkHeaderPresence(), 100);
      }
    });
  }
}

customElements.define('hamburger-drawer-tabs', HamburgerDrawerTabs);

document.addEventListener('shopify:section:unload', (event) => {
  let _target = event.target;
  if (_target.querySelector('age-verification') || _target.querySelector('newsletter-popup') || _target.querySelector('cart-drawer') || _target.querySelector('quick-view-drawer')) {
    document.body.classList.remove('overflow-hidden');
  }
});

class CountdownTimer extends HTMLElement {
    constructor() {
      super();

      const endDateStr = this.dataset.endDate; // format: DD/MM/YYYY
    

      if (!endDateStr) return;

      const [endD, endM, endY] = endDateStr.split('/').map(Number);
      // Basic validation for day, month, and year
      const isValidDate = (
        !isNaN(endD) && endD >= 1 && endD <= 31 &&
        !isNaN(endM) && endM >= 1 && endM <= 12 &&
        !isNaN(endY) && endY >= new Date().getFullYear()
      );
    
      if (!isValidDate) {
        console.error('Invalid end date provided for countdown timer:', endDateStr);
        this.style.display = 'none'; // Hide the countdown timer element
        return; 
      }

      this.endDate = new Date(endY, endM - 1, endD, 23, 59, 59);

      this.daysSpan = this.querySelector('[data-days]');
      this.hoursSpan = this.querySelector('[data-hours]');
      this.minutesSpan = this.querySelector('[data-minutes]');
      this.secondsSpan = this.querySelector('[data-seconds]');
      this.interLinking = this.dataset.linkCode;

      this.updateCountdown();
      this.timerInterval = setInterval(() => this.updateCountdown(), 1000);
    }

    updateCountdown() {
      const now = new Date();
      const distance = this.endDate - now;
      if (distance <= 0) {
        const section = this.closest('.shopify-section');
        const discountEl = section?.querySelector('copy-discount');
      
        if (this.interLinking === 'true' && discountEl) {
    discountEl.classList.add('hidden');
  }
        //this.innerHTML = `<span class="body-font text-small">Offer expired!</span>`;
        if(this.querySelector('[data-offer-text]') && this.querySelector('[data-offer-text]').textContent.trim() !== ''){
          this.querySelector('[data-offer-text]').classList.add('hidden');
        }
        if(this.querySelector('[data-end-note]') && this.querySelector('[data-end-note]').textContent.trim() !== ''){
          this.querySelector('[data-end-note]').classList.remove('hidden'); 
        }
        clearInterval(this.timerInterval);
        return;
      }
      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      if (this.daysSpan) {
        this.daysSpan.textContent = String(days).padStart(2, '0');
      }
      if (this.hoursSpan) {
        this.hoursSpan.textContent = String(hours).padStart(2, '0');
      }
      if (this.minutesSpan) {
        this.minutesSpan.textContent = String(minutes).padStart(2, '0');
      }
      if (this.secondsSpan) {
        this.secondsSpan.textContent = String(seconds).padStart(2, '0');
      }

    }
}

customElements.define('count-down', CountdownTimer);

class ProductBundle extends HTMLButtonElement {
  constructor() {
    super();

    this.section = this.closest('.shopify-section');
    this.sectionEl = this.section?.querySelector('bundle-popup');
    this.drawerID = this.sectionEl?.dataset.sectionId;

    this.init();
  }

  init() {
    this.addEventListener('click', this.onClick.bind(this));
  }

  connectedCallback() {
    this.setupCloseListeners();

    if (Shopify.designMode) {
      this._onSectionLoad = this.replacePopup.bind(this);
      document.addEventListener('shopify:section:load', this._onSectionLoad);
      document.addEventListener('shopify:section:unload', this._onSectionLoad);
    }
  }

  disconnectedCallback() {
    if (this._onSectionLoad) {
      document.removeEventListener('shopify:section:load', this._onSectionLoad);
      document.removeEventListener('shopify:section:unload', this._onSectionLoad);
    }
  }

  onClick(e) {
    e.preventDefault();

    document
      .querySelector('.click-focus-element')
      ?.classList.remove('click-focus-element');

    this.classList.add('click-focus-element');

    this.toggleSpinner(true); // Show spinner
    this.targetCard = Number(this.dataset.cardIndex) || 0;
    this.fetchProduct();
  }

  toggleSpinner(show = true) {
    const button = this.submitButton || this;
    if (!button) return;
  
    const label = button.querySelector('[data-bundle-button]');
    let loader = button.querySelector('[data-btn-loader]');
  
    if (show) {
      // Hide text/icon
      label?.classList.add('hidden');
  
      // Prevent duplicate loaders
      if (!loader) {
        button.insertAdjacentHTML(
          'beforeend',
          `<span class="btn-loader" data-btn-loader>
              <span class="svg-inside">
              <svg fill="currentColor" viewBox="0 0 24 24" class="icon-btn-loader">
                <circle cx="4" cy="12" r="3">
                <animate id="spinner_jObz" begin="0;spinner_vwSQ.end-0.25s" attributeName="r" dur="0.75s" values="3;.2;3"/>
                </circle>
                <circle cx="12" cy="12" r="3">
                <animate begin="spinner_jObz.end-0.6s" attributeName="r" dur="0.75s" values="3;.2;3"/>
                </circle>
                <circle cx="20" cy="12" r="3">
                <animate id="spinner_vwSQ" begin="spinner_jObz.end-0.45s" attributeName="r" dur="0.75s" values="3;.2;3"/>
                </circle>
              </svg>
              </span>
            </span>
          `
        );
      }
    } else {
      // Remove loader
      loader?.remove();
  
      // Restore text/icon
      label?.classList.remove('hidden');
    }
  }
  

  replacePopup() {
    const openPopup = document.querySelector(`bundle-popup[data-section-id="${this.drawerID}"].offcanvas-open`);
    if (openPopup) openPopup.remove();

  }

  fetchProduct() {
    const sectionId = this.drawerID;
    const blockId = this.dataset.blockId;
    const url = `${this.dataset.productUrl}?section_id=${sectionId}`;

    fetch(url)
      .then(r => r.text())
      .then(html => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const newPopup = doc.querySelector(`bundle-popup[data-section-id="${sectionId}"]`);

        if (!newPopup) return;
        document.querySelector(`bundle-popup[data-section-id="${sectionId}"]`)?.remove();
  
        document.body.appendChild(newPopup);
        this.drawer = newPopup;

        this.setupCloseListeners();
        this.toggleSpinner(false);
        this.open();
         // Hide spinner

        requestAnimationFrame(() => {
          this.highlightMatchingBlock(blockId, sectionId);
        });
      })
      .catch(console.error);
  }

  setupCloseListeners() {
    if (!this.drawer) return;

    this.drawer
      .querySelectorAll('[data-offcanvas-close], [offcanvas-close]')
      .forEach(btn => {
        btn.addEventListener('click', e => {
          e.preventDefault();
          this.close();
        });
      });

    document.addEventListener('keyup', e => {
      if (e.code === 'Escape') this.close();
    });
  }

  highlightMatchingBlock(blockId, sectionId) {
    if (!blockId) return;

    const popup = document.querySelector(`bundle-popup[data-section-id="${sectionId}"]`);
    if (!popup) return;

    const slides = popup.querySelectorAll('[data-bundle-block]');
    const targetSlide = popup.querySelector(`[data-bundle-block="${blockId}"]`);
    if (!targetSlide) return;

    slides.forEach(slide => {
      slide.classList.add('hidden');
    });
  
    targetSlide.classList.remove('hidden');

    setTimeout(() => {
      const cards = targetSlide.querySelectorAll('.bundle-popup-card');
      const card = cards[this.targetCard];
      card?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }, 300);
  }

  open() {
    const openDrawers = document.querySelector(`bundle-popup[data-section-id="${this.drawerID}"]`);
    openDrawers.classList.add("offcanvas-open");
    overflowAdd();
    this.drawer && trapFocus(this.drawer);
  }

  close() {
    const openDrawers = document.querySelector(`bundle-popup[data-section-id="${this.drawerID}"]`);
    openDrawers.classList.remove("offcanvas-open");
    overflowRemove();

    const el = document.querySelector('.click-focus-element');
    el?.focus();
    el?.classList.remove('click-focus-element');
  }
}

customElements.define('product-bundle', ProductBundle, { extends: 'button' });


  customElements.define(
    'bundle-popup',
    class Bundlepopup extends HTMLElement {
      constructor() {
        super();
        this.onBodyClick = this.handleBodyClick.bind(this);
      }

      connectedCallback() {

        const closeButtons = [
          this.querySelector('[data-offcanvas-close]'),
          this.querySelector('[offcanvas-close]')
        ];

        closeButtons.forEach((btn) => {
          if (btn) {
            btn.addEventListener('click', (e) => {
              e.preventDefault();
              this.hide(this.drawername);
            });
          }
        });

        this.addEventListener('keyup', (event) => {
          if (event.code.toUpperCase() === 'ESCAPE') this.hide(this.drawername);
        });
      }

      handleBodyClick(evt) {
        const target = evt.target;
        if (
          target != this &&
          !target.closest('bundle-popup') &&
          target.id != 'ShowPickupAvailabilityDrawer'
        ) {
          this.hide();
        }
      }
      
      hide() {
        this.classList.remove('offcanvas-open');
        this.removeAttribute('open');
        overflowRemove();
      }

      show(focusElement) {
        this.focusElement = focusElement;
        this.setAttribute('open', '');
        this.classList.add('offcanvas-open');
        overflowAdd();
        setTimeout(() => {
          trapFocus(this);
        }, 500);
      }
    }
  );

  class AnimatedCursor extends HTMLElement {
    constructor() {
      super();
  
      this.cursorScope = this.closest('.shopify-section');
      if (!this.cursorScope || !window.gsap) return;
  
      this.pageMouse = { x: 0, y: 0 };
      this.enabled = false;
  
      this.xTo = null;
      this.yTo = null;
  
      this.onMouseMove = this.onMouseMove.bind(this);
      this.onSectionEnter = this.onSectionEnter.bind(this);
      this.onSectionLeave = this.onSectionLeave.bind(this);
      this.onTargetEnter = this.onTargetEnter.bind(this);
      this.onTargetLeave = this.onTargetLeave.bind(this);
      this.handleBreakpointChange = this.handleBreakpointChange.bind(this);
      this.touchDevice = window.matchMedia('(pointer: coarse)').matches;
  
      // same mobile rule
      this.mq = window.matchMedia('(max-width: 767px)');
      this.mq.addEventListener('change', this.handleBreakpointChange);
  
      this.handleBreakpointChange(this.mq);

      
    }
  
    handleBreakpointChange(e) {
      if (e.matches) this.disableCursor();
      else this.enableCursor();

      if (this.touchDevice) {
        this.cursorScope.classList.add('touch-device');
      } else {
        this.cursorScope.classList.remove('touch-device');
      }
    }
  
    enableCursor() {
      if (this.enabled) return;
      this.enabled = true;
  
      this.style.display = 'none';
  
      // GSAP setup
      gsap.set(this, { xPercent: -50, yPercent: -50 });
  
      this.xTo = gsap.quickTo(this, 'x', {
        duration: 0.45,
        ease: 'power3.out'
      });
  
      this.yTo = gsap.quickTo(this, 'y', {
        duration: 0.45,
        ease: 'power3.out'
      });
  
      // section-scoped listeners
      this.cursorScope.addEventListener('mouseenter', this.onSectionEnter);
      this.cursorScope.addEventListener('mouseleave', this.onSectionLeave);
      this.cursorScope.addEventListener('mousemove', this.onMouseMove);
  
      // hover targets for floating-play
      this.cursorScope
        .querySelectorAll('[cursor-class]')
        .forEach((el) => {
          el.addEventListener('mouseenter', this.onTargetEnter);
          el.addEventListener('mouseleave', this.onTargetLeave);
        });
    }
  
    disableCursor() {
      if (!this.enabled) return;
      this.enabled = false;
  
      this.style.display = 'none';
  
      this.cursorScope.removeEventListener('mouseenter', this.onSectionEnter);
      this.cursorScope.removeEventListener('mouseleave', this.onSectionLeave);
      this.cursorScope.removeEventListener('mousemove', this.onMouseMove);
  
      this.cursorScope
        .querySelectorAll('[cursor-class]')
        .forEach((el) => {
          el.removeEventListener('mouseenter', this.onTargetEnter);
          el.removeEventListener('mouseleave', this.onTargetLeave);
        });
  
      this.xTo = null;
      this.yTo = null;
    }
  
    onSectionEnter(e) {
      this.style.display = 'block';
      this.updatePosition(e);
    }
  
    onSectionLeave() {
      this.style.display = 'none';
      this.classList.remove('floating-play');
    }
  
    onMouseMove(e) {
      this.updatePosition(e);
    }
  
    updatePosition(e) {
      if (!this.xTo || !this.yTo) return;
  
      const rect = this.cursorScope.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;
  
      this.xTo(x);
      this.yTo(y);
    }
  
    onTargetEnter(e) {
      const type = e.currentTarget.getAttribute('cursor-class');
      if (type === 'video') {
        this.classList.add('floating-play');
      }
    }
  
    onTargetLeave() {
      this.classList.remove('floating-play');
    }
  }
  
  customElements.define('animated-cursor', AnimatedCursor);
  

  class SecondaryMedia extends HTMLElement {
    constructor() {
      super();
    }
  
    connectedCallback() {
      const template = this.previousElementSibling;
  
      if (!(template instanceof HTMLTemplateElement)) return;
  
      this.appendChild(template.content.cloneNode(true));
    }
  }
  
  customElements.define('secondary-media', SecondaryMedia);
  